window.agozDeviceData = {
  "handsets": {
    "Ascom": [
      {
        "name": "Ascom 914T Pager",
        "url": "/collections/ascom-914t-business-handset-accessories"
      },
      {
        "name": "Ascom A51 Pager",
        "url": "/collections/ascom-a51-business-handset-accessories"
      },
      {
        "name": "Ascom Cases and",
        "url": "/collections/ascom-a72-business-handset-accessories"
      },
      {
        "name": "Ascom d43",
        "url": "/collections/ascom-d43-business-handset-accessories"
      },
      {
        "name": "Ascom d63",
        "url": "/collections/ascom-d63-business-handset-accessories"
      },
      {
        "name": "Ascom d83 DECT Handset",
        "url": "/collections/ascom-d83-business-handset-accessories"
      },
      {
        "name": "Ascom Handset",
        "url": "/collections/ascom-business-handsets-accessories"
      },
      {
        "name": "Ascom i63",
        "url": "/collections/ascom-i63-business-handset-accessories"
      },
      {
        "name": "Ascom Myco 3",
        "url": "/collections/ascom-myco-3-business-handset-accessories"
      },
      {
        "name": "Ascom Myco 4",
        "url": "/collections/ascom-myco-4-business-handset-accessories"
      },
      {
        "name": "Ascom Myco Smartphone",
        "url": "/collections/ascom-myco-business-handset-accessories"
      }
    ],
    "Cisco": [
      {
        "name": "Cisco 7925G VoIP Handset",
        "url": "/collections/cisco-7925g-business-handset-accessories"
      },
      {
        "name": "Cisco 8821 Wireless IP Handset",
        "url": "/collections/cisco-8821-business-handset-accessories"
      },
      {
        "name": "Cisco Wireless IP DECT Handset",
        "url": "/collections/cisco-business-handsets-accessories"
      },
      {
        "name": "Cisco Wireless Phone 860",
        "url": "/collections/cisco-860-business-handset-accessories"
      }
    ],
    "Gigaset": [
      {
        "name": "Gigaset DECT Handset",
        "url": "/collections/gigaset-business-handsets-accessories"
      }
    ],
    "Mitel": [
      {
        "name": "Mitel 5634 Case & Holster",
        "url": "/collections/mitel-5634-business-handset-accessories"
      },
      {
        "name": "Mitel 600 DECT Case & Holster",
        "url": "/collections/mitel-600-dect-business-handset-accessories"
      },
      {
        "name": "Mitel 612d/dt Case & Holster",
        "url": "/collections/mitel-612d-dt-business-handset-accessories"
      },
      {
        "name": "Mitel 622d/dt Case & Holster",
        "url": "/collections/mitel-622d-dt-business-handset-accessories"
      },
      {
        "name": "Mitel 632d/dt Case & Holster",
        "url": "/collections/mitel-632d-dt-business-handset-accessories"
      },
      {
        "name": "Mitel Wireless Terminals",
        "url": "/collections/mitel-business-handsets-accessories"
      }
    ],
    "Panasonic": [
      {
        "name": "Panasonic Mobile Handsets Case, Pouch",
        "url": "/collections/panasonic-business-handsets-accessories"
      }
    ],
    "Poly Rove": [
      {
        "name": "Poly Rove 20 Phone Holster & Case",
        "url": "/collections/poly-rove-20-business-handset-accessories"
      },
      {
        "name": "Poly Rove 30 Phone Holster & Case",
        "url": "/collections/poly-rove-30-business-handset-accessories"
      },
      {
        "name": "Poly Rove 40 Phone Holster & Case",
        "url": "/collections/poly-rove-40-business-handset-accessories"
      },
      {
        "name": "Poly Rove DECT Terminal",
        "url": "/collections/poly-rove-business-handsets-accessories"
      }
    ],
    "Samsung": [
      {
        "name": "Samsung Galaxy XCover",
        "url": "/collections/samsung-business-handsets-accessories"
      },
      {
        "name": "Samsung Galaxy XCover 6 Pro",
        "url": "/collections/samsung-galaxy-xcover-6-pro-business-handset-accessories"
      },
      {
        "name": "Samsung Galaxy XCover 7",
        "url": "/collections/samsung-galaxy-xcover-7-business-handset-accessories"
      }
    ],
    "Spectralink": [
      {
        "name": "Spectralink 72-Series Case & Holster",
        "url": "/collections/spectralink-72-business-handset-accessories"
      },
      {
        "name": "Spectralink 75-Series Case & Holster",
        "url": "/collections/spectralink-75-business-handset-accessories"
      },
      {
        "name": "Spectralink 76-Series Case & Holster",
        "url": "/collections/spectralink-76-business-handset-accessories"
      },
      {
        "name": "Spectralink 77-Series Case & Holster",
        "url": "/collections/spectralink-77-business-handset-accessories"
      },
      {
        "name": "Spectralink 8400 Case & Holster",
        "url": "/collections/spectralink-8400-business-handset-accessories"
      },
      {
        "name": "Spectralink 8440 Case & Holster",
        "url": "/collections/spectralink-8440-business-handset-accessories"
      },
      {
        "name": "Spectralink 8441 Case & Holster",
        "url": "/collections/spectralink-8441-business-handset-accessories"
      },
      {
        "name": "Spectralink Versity 9240 Smartphone",
        "url": "/collections/spectralink-versity-9240-business-handset-accessories"
      },
      {
        "name": "Spectralink Versity 9253 Case & Holster",
        "url": "/collections/spectralink-versity-9253-business-handset-accessories"
      },
      {
        "name": "Spectralink Wireless Smart Handsets",
        "url": "/collections/spectralink-business-handsets-accessories"
      }
    ],
    "Yealink": [
      {
        "name": "Yealink W56 Series Holster & Case",
        "url": "/collections/yealink-w56-business-handset-accessories"
      },
      {
        "name": "Yealink Wireless Handset",
        "url": "/collections/yealink-business-handsets-accessories"
      }
    ]
  },
  "pos": {
    "Adyen": [
      {
        "name": "Adyen AMS1 POS",
        "url": "/collections/adyen-ams1-pos-accessories"
      },
      {
        "name": "Adyen Mobile POS Terminal",
        "url": "/collections/adyen-pos-accessories"
      },
      {
        "name": "Adyen NYC1",
        "url": "/collections/adyen-nyc1-pos-accessories"
      },
      {
        "name": "Adyen P630 POS",
        "url": "/collections/adyen-p630-pos-accessories"
      },
      {
        "name": "Adyen S1E",
        "url": "/collections/adyen-s1e-pos-accessories"
      },
      {
        "name": "Adyen S1E2L POS",
        "url": "/collections/adyen-s1e2l-pos-accessories"
      },
      {
        "name": "Adyen S1F2 POS",
        "url": "/collections/adyen-s1f2-pos-accessories"
      },
      {
        "name": "Adyen S1F2L",
        "url": "/collections/adyen-s1f2l-pos-accessories"
      },
      {
        "name": "Adyen S1F4 / S1F4 PRO Terminal",
        "url": "/collections/adyen-s1f4-s1f4-pro-pos-accessories"
      },
      {
        "name": "Adyen V400m",
        "url": "/collections/adyen-v400m-pos-accessories"
      },
      {
        "name": "Adyen Verifone V210",
        "url": "/collections/adyen-verifone-v210-pos-accessories"
      }
    ],
    "Castles": [
      {
        "name": "Castles Castes S1F3CT Mobile Terminal",
        "url": "/collections/castles-s1f3ct-pos-accessories"
      },
      {
        "name": "Castles POS Terminal",
        "url": "/collections/castles-pos-accessories"
      },
      {
        "name": "Castles S1E2 POS",
        "url": "/collections/castles-s1e2-pos-accessories"
      },
      {
        "name": "Castles S1F2 POS",
        "url": "/collections/castles-s1f2-pos-accessories"
      },
      {
        "name": "Castles S1F3 POS",
        "url": "/collections/castles-s1f3-pos-accessories"
      },
      {
        "name": "Castles S1F4 / S1F4 PRO Payment Terminal",
        "url": "/collections/castles-s1f4-s1f4-pro-pos-accessories"
      },
      {
        "name": "Castles S1Mini / S1Mini2 POS",
        "url": "/collections/castles-s1-mini-pos-accessories"
      },
      {
        "name": "Castles S1P S1P2 POS",
        "url": "/collections/castles-s1p-pos-accessories"
      },
      {
        "name": "Castles Saturn S1E2 smartPOS",
        "url": "/collections/castles-saturn-s1e2-pos-accessories"
      },
      {
        "name": "Castles V1M Mobile Terminal",
        "url": "/collections/castles-v1m-pos-accessories"
      },
      {
        "name": "Castles V3CT3 POS",
        "url": "/collections/castles-v3ct3-pos-accessories"
      },
      {
        "name": "Castles V3M2 POS",
        "url": "/collections/castles-v3m2-pos-accessories"
      },
      {
        "name": "Castles V3P3 PIN Pad POS",
        "url": "/collections/castles-v3p3-pos-accessories"
      },
      {
        "name": "Castles Vega Move POS",
        "url": "/collections/castles-vega-move-pos-accessories"
      },
      {
        "name": "Castles VEGA3000 Countertop POS",
        "url": "/collections/castles-vega3000-pos-accessories"
      }
    ],
    "Clover": [
      {
        "name": "Clover C600 Card Reader",
        "url": "/collections/clover-c600-pos-accessories"
      },
      {
        "name": "Clover Compact POS",
        "url": "/collections/clover-compact-pos-accessories"
      },
      {
        "name": "Clover Flex 3 (C405) POS",
        "url": "/collections/clover-flex-3-c405-pos-accessories"
      },
      {
        "name": "Clover Flex 4 (C406) POS",
        "url": "/collections/clover-flex-4-pos-accessories"
      },
      {
        "name": "Clover Flex Handheld POS",
        "url": "/collections/clover-flex-pos-accessories"
      },
      {
        "name": "Clover Flex Pocket POS",
        "url": "/collections/clover-flex-pocket-pos-accessories"
      },
      {
        "name": "Clover Go (3rd Gen) POS",
        "url": "/collections/clover-go-3rd-gen-pos-accessories"
      },
      {
        "name": "Clover Go POS",
        "url": "/collections/clover-go-pos-accessories"
      },
      {
        "name": "Clover Mini 2 (C302U) POS",
        "url": "/collections/clover-mini-2-c302u-pos-accessories"
      },
      {
        "name": "Clover Mini 3 (C305) Terminal",
        "url": "/collections/clover-mini-3-c305-pos-accessories"
      },
      {
        "name": "Clover Mini POS Terminal",
        "url": "/collections/clover-mini-pos-accessories"
      },
      {
        "name": "Clover POS Terminal",
        "url": "/collections/clover-pos-accessories"
      }
    ],
    "Dejavoo": [
      {
        "name": "Dejavoo P1 Terminal",
        "url": "/collections/dejavoo-p1-pos-accessories"
      },
      {
        "name": "Dejavoo P17 POS",
        "url": "/collections/dejavoo-p17-pos-accessories"
      },
      {
        "name": "Dejavoo P3 Terminal",
        "url": "/collections/dejavoo-p3-pos-accessories"
      },
      {
        "name": "Dejavoo P5 Terminal",
        "url": "/collections/dejavoo-p5-pos-accessories"
      },
      {
        "name": "Dejavoo POS Terminal",
        "url": "/collections/dejavoo-pos-accessories"
      },
      {
        "name": "Dejavoo QD1 Terminal",
        "url": "/collections/dejavoo-qd1-pos-accessories"
      },
      {
        "name": "Dejavoo QD2 Terminal",
        "url": "/collections/dejavoo-qd2-pos-accessories"
      },
      {
        "name": "Dejavoo QD3 Terminal",
        "url": "/collections/dejavoo-qd3-pos-accessories"
      },
      {
        "name": "Dejavoo QD4 Terminal",
        "url": "/collections/dejavoo-qd4-pos-accessories"
      },
      {
        "name": "Dejavoo QD5 Terminal",
        "url": "/collections/dejavoo-qd5-pos-accessories"
      },
      {
        "name": "Dejavoo Z11 Terminal",
        "url": "/collections/dejavoo-z11-pos-accessories"
      },
      {
        "name": "Dejavoo Z3 PIN Pad Holder",
        "url": "/collections/dejavoo-z3-pos-accessories"
      },
      {
        "name": "Dejavoo Z6 Countertop POS",
        "url": "/collections/dejavoo-z6-pos-accessories"
      },
      {
        "name": "Dejavoo Z8 Terminal",
        "url": "/collections/dejavoo-z8-pos-accessories"
      },
      {
        "name": "Dejavoo Z9 Terminal",
        "url": "/collections/dejavoo-z9-pos-accessories"
      }
    ],
    "GoDaddy": [
      {
        "name": "GoDaddy POS Terminal",
        "url": "/collections/godaddy-pos-accessories"
      },
      {
        "name": "GoDaddy Poynt Card Reader",
        "url": "/collections/godaddy-poynt-pos-accessories"
      },
      {
        "name": "GoDaddy Smart Terminal Flex",
        "url": "/collections/godaddy-smart-pos-accessories"
      }
    ],
    "Ingenico": [
      {
        "name": "Ingenico Apos A8",
        "url": "/collections/ingenico-apos-a8-pos-accessories"
      },
      {
        "name": "Ingenico Axium DX4000",
        "url": "/collections/ingenico-axium-dx4000-pos-accessories"
      },
      {
        "name": "Ingenico Axium DX8000",
        "url": "/collections/ingenico-axium-dx8000-pos-accessories"
      },
      {
        "name": "Ingenico Axium EX4000",
        "url": "/collections/ingenico-axium-ex4000-pos-accessories"
      },
      {
        "name": "Ingenico Axium EX6000",
        "url": "/collections/ingenico-axium-ex6000-pos-accessories"
      },
      {
        "name": "Ingenico Axium EX8000",
        "url": "/collections/ingenico-axium-ex8000-pos-accessories"
      },
      {
        "name": "Ingenico Axium RX5000 PIN Pad",
        "url": "/collections/ingenico-axium-rx5000-pos-accessories"
      },
      {
        "name": "Ingenico Axium RX7000 SmartPOS",
        "url": "/collections/ingenico-axium-rx7000-pos-accessories"
      },
      {
        "name": "Ingenico Axium RX9000 POS Terminal",
        "url": "/collections/ingenico-axium-rx9000-pos-accessories"
      },
      {
        "name": "Ingenico Desk/1500 PIN Pad Stand, Holder, & Mounts",
        "url": "/collections/ingenico-desk-1500-pos-accessories"
      },
      {
        "name": "Ingenico Desk/1600 PIN Pad Mounts",
        "url": "/collections/ingenico-desk-1600-pos-accessories"
      },
      {
        "name": "Ingenico Desk/1700 Terminal",
        "url": "/collections/ingenico-desk-1700-pos-accessories"
      },
      {
        "name": "Ingenico Desk/2600 POS",
        "url": "/collections/ingenico-desk-2600-pos-accessories"
      },
      {
        "name": "Ingenico Desk/3500 Countertop",
        "url": "/collections/ingenico-desk-3500-pos-accessories"
      },
      {
        "name": "Ingenico Desk/5000 PIN Pad Mounts",
        "url": "/collections/ingenico-desk-5000-pos-accessories"
      },
      {
        "name": "Ingenico iPP310 PIN Pad POS",
        "url": "/collections/ingenico-ipp310-pos-accessories"
      },
      {
        "name": "Ingenico iPP315 Terminal",
        "url": "/collections/ingenico-ipp315-pos-accessories"
      },
      {
        "name": "Ingenico iPP320 Mounts",
        "url": "/collections/ingenico-ipp320-pos-accessories"
      },
      {
        "name": "Ingenico iPP350 Card Reader",
        "url": "/collections/ingenico-ipp350-pos-accessories"
      },
      {
        "name": "Ingenico iSMP4",
        "url": "/collections/ingenico-ismp4-pos-accessories"
      },
      {
        "name": "Ingenico iWL220",
        "url": "/collections/ingenico-iwl220-pos-accessories"
      },
      {
        "name": "Ingenico iWL250",
        "url": "/collections/ingenico-iwl250-pos-accessories"
      },
      {
        "name": "Ingenico iWL255",
        "url": "/collections/ingenico-iwl255-pos-accessories"
      },
      {
        "name": "Ingenico Lane 5000 POS Swivel",
        "url": "/collections/ingenico-lane-5000-pos-accessories"
      },
      {
        "name": "Ingenico Lane 7000 Payment Terminal Swivel",
        "url": "/collections/ingenico-lane-7000-pos-accessories"
      },
      {
        "name": "Ingenico Lane/3000 Terminal",
        "url": "/collections/ingenico-lane-3000-pos-accessories"
      },
      {
        "name": "Ingenico Lane/3600 POS Mounting",
        "url": "/collections/ingenico-lane-3600-pos-accessories"
      },
      {
        "name": "Ingenico Lane/8000 Terminal",
        "url": "/collections/ingenico-lane-8000-pos-accessories"
      },
      {
        "name": "Ingenico Link 2500",
        "url": "/collections/ingenico-link-2500-pos-accessories"
      },
      {
        "name": "Ingenico Mobile POS Terminal",
        "url": "/collections/ingenico-pos-accessories"
      },
      {
        "name": "Ingenico Moby 5500",
        "url": "/collections/ingenico-moby-5500-pos-accessories"
      },
      {
        "name": "Ingenico Moby 6500",
        "url": "/collections/ingenico-moby-6500-pos-accessories"
      },
      {
        "name": "Ingenico Moby 8500",
        "url": "/collections/ingenico-moby-8500-pos-accessories"
      },
      {
        "name": "Ingenico Moby, Link and iSMP3 Series Cable | Charger",
        "url": "/collections/ingenico-moby-3000-5000-8500-link-2500-ismp3-cable-charger"
      },
      {
        "name": "Ingenico Moby/9500",
        "url": "/collections/ingenico-moby-9500-pos-accessories"
      },
      {
        "name": "Ingenico Move 2500",
        "url": "/collections/ingenico-move-2500-pos-accessories"
      },
      {
        "name": "Ingenico Move 3500",
        "url": "/collections/ingenico-move-3500-pos-accessories"
      },
      {
        "name": "Ingenico Move 5000",
        "url": "/collections/ingenico-move-5000-pos-accessories"
      },
      {
        "name": "Ingenico Move ATEX",
        "url": "/collections/ingenico-move-atex-pos-accessories"
      },
      {
        "name": "Ingenico Move/2600",
        "url": "/collections/ingenico-move-2600-pos-accessories"
      },
      {
        "name": "Ingenico Payment Terminal",
        "url": "/collections/ingenico-payment-terminal-stands-and-mounts"
      },
      {
        "name": "Ingenico Roam RP750x",
        "url": "/collections/ingenico-roam-rp750x-pos-accessories"
      }
    ],
    "Orderman": [
      {
        "name": "Orderman 10",
        "url": "/collections/orderman-10-pos-accessories"
      },
      {
        "name": "Orderman 5",
        "url": "/collections/orderman-5-pos-accessories"
      },
      {
        "name": "Orderman 9",
        "url": "/collections/orderman-9-pos-accessories"
      },
      {
        "name": "Orderman POS",
        "url": "/collections/orderman-pos-accessories"
      },
      {
        "name": "Orderman Pulse OX9",
        "url": "/collections/orderman-pulse-ox9-pos-accessories"
      }
    ],
    "PAX": [
      {
        "name": "PAX A30 / Q30 Terminal",
        "url": "/collections/pax-a30-q30-pos-accessories"
      },
      {
        "name": "PAX A35 PINPad Terminal",
        "url": "/collections/pax-a35-pos-accessories"
      },
      {
        "name": "PAX A50 POS",
        "url": "/collections/pax-a50-pos-accessories"
      },
      {
        "name": "PAX A50S POS",
        "url": "/collections/pax-a50s-pos-accessories"
      },
      {
        "name": "PAX A60 POS",
        "url": "/collections/pax-a60-pos-accessories"
      },
      {
        "name": "PAX A6630",
        "url": "/collections/pax-a6630-pos-accessories"
      },
      {
        "name": "PAX A6650 POS",
        "url": "/collections/pax-a6650-pos-accessories"
      },
      {
        "name": "PAX A77 POS",
        "url": "/collections/pax-a77-pos-accessories"
      },
      {
        "name": "PAX A80 POS",
        "url": "/collections/pax-a80-pos-accessories"
      },
      {
        "name": "PAX A800 POS",
        "url": "/collections/pax-a800-pos-accessories"
      },
      {
        "name": "PAX A8500 POS",
        "url": "/collections/pax-a8500-pos-accessories"
      },
      {
        "name": "PAX A8700 POS",
        "url": "/collections/pax-a8700-pos-accessories"
      },
      {
        "name": "PAX A910s POS",
        "url": "/collections/pax-a910s-pos-accessories"
      },
      {
        "name": "PAX A920 Max POS",
        "url": "/collections/pax-a920-max-pos-accessories"
      },
      {
        "name": "PAX A920 POS",
        "url": "/collections/pax-a920-pos-accessories"
      },
      {
        "name": "PAX A920 Pro POS",
        "url": "/collections/pax-a920-pro-pos-accessories"
      },
      {
        "name": "PAX A930 POS",
        "url": "/collections/pax-a930-pos-accessories"
      },
      {
        "name": "PAX A960 POS",
        "url": "/collections/pax-a960-pos-accessories"
      },
      {
        "name": "PAX A99 Handheld POS",
        "url": "/collections/pax-a99-pos-accessories"
      },
      {
        "name": "PAX Aries 8 / Aries 6 Terminal",
        "url": "/collections/pax-aries-8-aries-6-pos-accessories"
      },
      {
        "name": "PAX D190 POS",
        "url": "/collections/pax-d190-pos-accessories"
      },
      {
        "name": "PAX D195 POS",
        "url": "/collections/pax-d195-pos-accessories"
      },
      {
        "name": "PAX D220 POS",
        "url": "/collections/pax-d220-pos-accessories"
      },
      {
        "name": "PAX D230 POS",
        "url": "/collections/pax-d230-pos-accessories"
      },
      {
        "name": "PAX D270 POS",
        "url": "/collections/pax-d270-pos-accessories"
      },
      {
        "name": "PAX Elys Case, Holster",
        "url": "/collections/pax-elys-tablet-accessories"
      },
      {
        "name": "PAX M50 POS",
        "url": "/collections/pax-m50-pos-accessories"
      },
      {
        "name": "PAX M8 Case, Holster",
        "url": "/collections/pax-m8-pos-accessories"
      },
      {
        "name": "PAX M9200 POS",
        "url": "/collections/pax-m9200-pos-accessories"
      },
      {
        "name": "PAX POS Terminal",
        "url": "/collections/pax-pos-accessories"
      },
      {
        "name": "PAX PX5 & PX7 Terminal",
        "url": "/collections/pax-px5-px7-pos-accessories"
      },
      {
        "name": "PAX Q25 Countertop POS",
        "url": "/collections/pax-q25-pos-accessories"
      },
      {
        "name": "PAX Q60 POS",
        "url": "/collections/pax-q60-pos-accessories"
      },
      {
        "name": "PAX Q80 Countertop POS Mounts",
        "url": "/collections/pax-q80-pos-accessories"
      },
      {
        "name": "PAX Q92 POS",
        "url": "/collections/pax-q92-pos-accessories"
      },
      {
        "name": "PAX S210 Keypad",
        "url": "/collections/pax-s210-pos-accessories"
      },
      {
        "name": "PAX S300 Terminal",
        "url": "/collections/pax-s300-pos-accessories"
      },
      {
        "name": "PAX S80 Countertop Terminal",
        "url": "/collections/pax-s80-pos-accessories"
      },
      {
        "name": "PAX S920 POS",
        "url": "/collections/pax-s920-pos-accessories"
      },
      {
        "name": "PAX SP30 Terminal",
        "url": "/collections/pax-sp30-pos-accessories"
      }
    ],
    "Saturn": [
      {
        "name": "Saturn 1000F2",
        "url": "/collections/saturn-1000f2-pos-accessories"
      },
      {
        "name": "Saturn POS Terminal",
        "url": "/collections/saturn-pos-accessories"
      }
    ],
    "Shift4": [
      {
        "name": "Shift4 One POS Terminal",
        "url": "/collections/shift4-one-pos-accessories"
      },
      {
        "name": "Shift4 POS Terminal",
        "url": "/collections/shift4-pos-accessories"
      },
      {
        "name": "Shift4 SkyTab Air POS Terminal",
        "url": "/collections/shift4-skytab-air-pos-accessories"
      }
    ],
    "Square": [
      {
        "name": "Square Contactless Reader Case & Holster, Charger",
        "url": "/collections/square-contactless-pos-accessories"
      },
      {
        "name": "Square Handheld POS",
        "url": "/collections/square-handheld-pos-accessories"
      },
      {
        "name": "Square Terminal POS",
        "url": "/collections/square-pos-accessories"
      }
    ],
    "Sunmi": [
      {
        "name": "Sunmi L2 Case & Holster",
        "url": "/collections/sunmi-l2-pos-accessories"
      },
      {
        "name": "Sunmi L2H Case & Holster",
        "url": "/collections/sunmi-l2h-pos-accessories"
      },
      {
        "name": "Sunmi L2K Case & Holster",
        "url": "/collections/sunmi-l2k-pos-accessories"
      },
      {
        "name": "Sunmi L2Ks Case & Holster",
        "url": "/collections/sunmi-l2ks-pos-accessories"
      },
      {
        "name": "Sunmi L2s Case & Holster",
        "url": "/collections/sunmi-l2s-pos-accessories"
      },
      {
        "name": "Sunmi L2s Pro",
        "url": "/collections/sunmi-l2s-pro-pos-accessories"
      },
      {
        "name": "Sunmi M2 Case & Holster",
        "url": "/collections/sunmi-m2-pos-accessories"
      },
      {
        "name": "Sunmi M2 Max Case",
        "url": "/collections/sunmi-m2-max-pos-accessories"
      },
      {
        "name": "Sunmi P2 Case & Holster",
        "url": "/collections/sunmi-p2-pos-accessories"
      },
      {
        "name": "Sunmi P2 Lite SE Case & Holster",
        "url": "/collections/sunmi-p2-lite-se-pos-accessories"
      },
      {
        "name": "Sunmi P2 Mini Case & Holster",
        "url": "/collections/sunmi-p2-mini-pos-accessories"
      },
      {
        "name": "Sunmi P2 Pro Case & Holster",
        "url": "/collections/sunmi-p2-pro-pos-accessories"
      },
      {
        "name": "Sunmi P2 SE Case & Holster",
        "url": "/collections/sunmi-p2-se-pos-accessories"
      },
      {
        "name": "Sunmi POS",
        "url": "/collections/sunmi-pos-accessories"
      },
      {
        "name": "Sunmi V2 Case & Holster",
        "url": "/collections/sunmi-v2-pos-accessories"
      },
      {
        "name": "Sunmi V2 Pro Case & Holster",
        "url": "/collections/sunmi-v2-pro-pos-accessories"
      },
      {
        "name": "Sunmi V2s Case & Holster",
        "url": "/collections/sunmi-v2s-pos-accessories"
      },
      {
        "name": "Sunmi V2s Plus Case & Holster",
        "url": "/collections/sunmi-v2s-plus-pos-accessories"
      }
    ],
    "Toast": [
      {
        "name": "Toast Go 2 Handheld",
        "url": "/collections/toast-go-2-pos-accessories"
      },
      {
        "name": "Toast Go 3 Handheld POS",
        "url": "/collections/toast-go-3-pos-accessories"
      },
      {
        "name": "Toast POS Terminal",
        "url": "/collections/toast-pos-accessories"
      },
      {
        "name": "Toast S1 Handheld POS",
        "url": "/collections/toast-s1-pos-accessories"
      }
    ],
    "Valor": [
      {
        "name": "Valor Paytech RCKT Mobile POS",
        "url": "/collections/valor-paytech-rckt-pos-accessories"
      },
      {
        "name": "Valor POS Terminal",
        "url": "/collections/valor-pos-accessories"
      },
      {
        "name": "Valor VL100/Pro Countertop POS",
        "url": "/collections/valor-vl100-pro-pos-accessories"
      },
      {
        "name": "Valor VL110",
        "url": "/collections/valor-vl110-pos-accessories"
      },
      {
        "name": "Valor VL300 Pin Pad POS",
        "url": "/collections/valor-vl300-pos-accessories"
      },
      {
        "name": "Valor VL500",
        "url": "/collections/valor-vl500-pos-accessories"
      },
      {
        "name": "Valor VL550 POS",
        "url": "/collections/valor-vl550-pos-accessories"
      },
      {
        "name": "Valor VP100 Countertop POS",
        "url": "/collections/valor-vp100-pos-accessories"
      },
      {
        "name": "Valor VP300 PIN Pad POS",
        "url": "/collections/valor-vp300-pos-accessories"
      },
      {
        "name": "Valor VP300 Pro POS",
        "url": "/collections/valor-vp300-pro-pos-accessories"
      },
      {
        "name": "Valor VP350 POS",
        "url": "/collections/valor-vp350-pos-accessories"
      },
      {
        "name": "Valor VP500",
        "url": "/collections/valor-vp500-pos-accessories"
      },
      {
        "name": "Valor VP550 POS",
        "url": "/collections/valor-vp550-pos-accessories"
      },
      {
        "name": "Valor VP550c Smart Countertop POS",
        "url": "/collections/valor-vp550c-smart-pos-accessories"
      },
      {
        "name": "Valor VP550E POS",
        "url": "/collections/valor-vp550e-pos-accessories"
      }
    ],
    "Verifone": [
      {
        "name": "Verifone Carbon Mobile 5 POS Case, Holster",
        "url": "/collections/verifone-carbon-mobile-5-pos-accessories"
      },
      {
        "name": "Verifone e235 POS Case, Holster",
        "url": "/collections/verifone-e235-pos-accessories"
      },
      {
        "name": "Verifone e280 POS Case, Holster",
        "url": "/collections/verifone-e280-pos-accessories"
      },
      {
        "name": "Verifone e280s POS Case, Holster",
        "url": "/collections/verifone-e280s-pos-accessories"
      },
      {
        "name": "Verifone e285 Case, Holster",
        "url": "/collections/verifone-e285-pos-accessories"
      },
      {
        "name": "Verifone e355 Case, Holster",
        "url": "/collections/verifone-e355-pos-accessories"
      },
      {
        "name": "Verifone M400 Payment Terminal",
        "url": "/collections/verifone-m400-pos-accessories"
      },
      {
        "name": "Verifone M424 M425 Pin Pad",
        "url": "/collections/verifone-m424-m425-pos-accessories"
      },
      {
        "name": "Verifone M440 M450 Terminal",
        "url": "/collections/verifone-m440-m450-pos-accessories"
      },
      {
        "name": "Verifone MX915 MX925 Terminal",
        "url": "/collections/verifone-mx915-mx925-pos-accessories"
      },
      {
        "name": "Verifone P200 Case, Holster",
        "url": "/collections/verifone-p200-pos-accessories"
      },
      {
        "name": "Verifone P400 Pin Pad Case, Holster",
        "url": "/collections/verifone-p400-pos-accessories"
      },
      {
        "name": "Verifone P630 POS Case, Holster",
        "url": "/collections/verifone-p630-pos-accessories"
      },
      {
        "name": "Verifone POS Terminal",
        "url": "/collections/verifone-pos-accessories"
      },
      {
        "name": "Verifone T650c POS Case, Holster",
        "url": "/collections/verifone-t650c-pos-accessories"
      },
      {
        "name": "Verifone T650m POS Case, Holster",
        "url": "/collections/verifone-t650m-pos-accessories"
      },
      {
        "name": "Verifone T650p POS Case, Holster",
        "url": "/collections/verifone-t650p-pos-accessories"
      },
      {
        "name": "Verifone V200c POS Case, Holster",
        "url": "/collections/verifone-v200c-pos-accessories"
      },
      {
        "name": "Verifone V200t POS Case, Holster",
        "url": "/collections/verifone-v200t-pos-accessories"
      },
      {
        "name": "Verifone V205c POS Case, Holster",
        "url": "/collections/verifone-v205c-pos-accessories"
      },
      {
        "name": "Verifone V210 POS Case, Holster",
        "url": "/collections/verifone-v210-pos-accessories"
      },
      {
        "name": "Verifone V240m POS Case, Holster",
        "url": "/collections/verifone-v240m-pos-accessories"
      },
      {
        "name": "Verifone V400c POS Case, Holster",
        "url": "/collections/verifone-v400c-pos-accessories"
      },
      {
        "name": "Verifone V400m POS Case, Holster",
        "url": "/collections/verifone-v400m-pos-accessories"
      },
      {
        "name": "Verifone V640m POS Case, Holster",
        "url": "/collections/verifone-v640m-pos-accessories"
      },
      {
        "name": "Verifone V660c POS Case, Holster",
        "url": "/collections/verifone-v660c-pos-accessories"
      },
      {
        "name": "Verifone V660P POS Case, Holster",
        "url": "/collections/verifone-v660p-pos-accessories"
      },
      {
        "name": "Verifone Victa POS Case, Holster",
        "url": "/collections/verifone-victa-pos-accessories"
      },
      {
        "name": "Verifone Victa Reader POS Case, Holster",
        "url": "/collections/verifone-victa-reader-pos-accessories"
      },
      {
        "name": "Verifone Vx 805 PIN Pad",
        "url": "/collections/verifone-vx-805-pos-accessories"
      },
      {
        "name": "Verifone Vx520 POS",
        "url": "/collections/verifone-vx-520-pos-accessories"
      },
      {
        "name": "Verifone Vx805 POS",
        "url": "/collections/verifone-vx805-pos-accessories"
      },
      {
        "name": "Verifone Vx820 PIN Pad EMV",
        "url": "/collections/verifone-vx-820-pos-accessories"
      },
      {
        "name": "Verifone X990 POS Case, Holster",
        "url": "/collections/verifone-x990-pos-accessories"
      }
    ],
    "iMin": [
      {
        "name": "iMin M2 POS",
        "url": "/collections/imin-m2-pos-accessories"
      },
      {
        "name": "Imin POS",
        "url": "/collections/imin-pos-accessories"
      },
      {
        "name": "iMin Swift 1 POS",
        "url": "/collections/imin-swift-1-pos-accessories"
      }
    ]
  },
  "scanners": {
    "Almex": [
      {
        "name": "Almex Scanner",
        "url": "/collections/almex-scanners-accessories"
      },
      {
        "name": "Almex TC601 Scanner",
        "url": "/collections/almex-tc601-scanner-accessories"
      },
      {
        "name": "Almex TC603 Scanner",
        "url": "/collections/almex-tc603-scanner-accessories"
      },
      {
        "name": "Almex TC605 Scanner",
        "url": "/collections/almex-tc605-scanner-accessories"
      }
    ],
    "Bluebird": [
      {
        "name": "Bluebird EF400",
        "url": "/collections/bluebird-ef400-scanner-accessories"
      },
      {
        "name": "Bluebird EF401",
        "url": "/collections/bluebird-ef401-scanner-accessories"
      },
      {
        "name": "Bluebird EF500",
        "url": "/collections/bluebird-ef500-scanner-accessories"
      },
      {
        "name": "Bluebird EF500R",
        "url": "/collections/bluebird-ef500r-scanner-accessories"
      },
      {
        "name": "Bluebird EF501",
        "url": "/collections/bluebird-ef501-scanner-accessories"
      },
      {
        "name": "Bluebird EF501R",
        "url": "/collections/bluebird-ef501r-scanner-accessories"
      },
      {
        "name": "Bluebird EF550",
        "url": "/collections/bluebird-ef550-scanner-accessories"
      },
      {
        "name": "Bluebird EF550R",
        "url": "/collections/bluebird-ef550r-scanner-accessories"
      },
      {
        "name": "Bluebird EF551",
        "url": "/collections/bluebird-ef551-scanner-accessories"
      },
      {
        "name": "Bluebird HF450",
        "url": "/collections/bluebird-hf450-scanner-accessories"
      },
      {
        "name": "Bluebird HF550",
        "url": "/collections/bluebird-hf550-scanner-accessories"
      },
      {
        "name": "Bluebird RP350",
        "url": "/collections/bluebird-rp350-scanner-accessories"
      },
      {
        "name": "Bluebird S20",
        "url": "/collections/bluebird-s20-scanner-accessories"
      },
      {
        "name": "Bluebird S50",
        "url": "/collections/bluebird-s50-scanner-accessories"
      },
      {
        "name": "Bluebird S70",
        "url": "/collections/bluebird-s70-scanner-accessories"
      },
      {
        "name": "Bluebird Scanner",
        "url": "/collections/bluebird-scanners-accessories"
      },
      {
        "name": "Bluebird SF550",
        "url": "/collections/bluebird-sf550-scanner-accessories"
      },
      {
        "name": "Bluebird SF650",
        "url": "/collections/bluebird-sf650-scanner-accessories"
      },
      {
        "name": "Bluebird VF550",
        "url": "/collections/bluebird-vf550-scanner-accessories"
      },
      {
        "name": "Bluebird VX500",
        "url": "/collections/bluebird-vx500-scanner-accessories"
      }
    ],
    "Chainway": [
      {
        "name": "Chainway C5 RFID Reader",
        "url": "/collections/chainway-c5-scanner-accessories"
      },
      {
        "name": "Chainway C60",
        "url": "/collections/chainway-c60-scanner-accessories"
      },
      {
        "name": "Chainway C6000",
        "url": "/collections/chainway-c6000-scanner-accessories"
      },
      {
        "name": "Chainway C61",
        "url": "/collections/chainway-c61-scanner-accessories"
      },
      {
        "name": "Chainway C66",
        "url": "/collections/chainway-c66-scanner-accessories"
      },
      {
        "name": "Chainway C70",
        "url": "/collections/chainway-c70-scanner-accessories"
      },
      {
        "name": "Chainway C71 Holster, Case",
        "url": "/collections/chainway-c71-scanner-accessories"
      },
      {
        "name": "Chainway C72 Case, Holster",
        "url": "/collections/chainway-c72-scanner-accessories"
      },
      {
        "name": "Chainway C75 Case, Holster",
        "url": "/collections/chainway-c75-scanner-accessories"
      },
      {
        "name": "Chainway C90 Case, Holster",
        "url": "/collections/chainway-c90-scanner-accessories"
      },
      {
        "name": "Chainway MC21 Case, Holster",
        "url": "/collections/chainway-mc21-scanner-accessories"
      },
      {
        "name": "Chainway MC50 Case, Holster",
        "url": "/collections/chainway-mc50-scanner-accessories"
      },
      {
        "name": "Chainway MC51 RFID Reader",
        "url": "/collections/chainway-mc51-scanner-accessories"
      },
      {
        "name": "Chainway MC62 Case, Holster",
        "url": "/collections/chainway-mc62-scanner-accessories"
      },
      {
        "name": "Chainway MC95 Scanner Case, Holster",
        "url": "/collections/chainway-mc95-scanner-accessories"
      },
      {
        "name": "Chainway R6 RFID Sled Reader",
        "url": "/collections/chainway-r6-scanner-accessories"
      },
      {
        "name": "Chainway Scanner",
        "url": "/collections/chainway-scanners-accessories"
      }
    ],
    "CipherLab": [
      {
        "name": "Cipherlab RK26",
        "url": "/collections/cipherlab-rk26-scanner-accessories"
      },
      {
        "name": "Cipherlab RK95",
        "url": "/collections/cipherlab-rk95-scanner-accessories"
      },
      {
        "name": "Cipherlab RS31",
        "url": "/collections/cipherlab-rs31-scanner-accessories"
      },
      {
        "name": "Cipherlab RS35",
        "url": "/collections/cipherlab-rs35-scanner-accessories"
      },
      {
        "name": "Cipherlab RS36",
        "url": "/collections/cipherlab-rs36-scanner-accessories"
      },
      {
        "name": "Cipherlab RS38 Scanner",
        "url": "/collections/cipherlab-rs38-scanner-accessories"
      },
      {
        "name": "Cipherlab RS50",
        "url": "/collections/cipherlab-rs50-scanner-accessories"
      },
      {
        "name": "Cipherlab RS51",
        "url": "/collections/cipherlab-rs51-scanner-accessories"
      },
      {
        "name": "Cipherlab Scanner",
        "url": "/collections/cipherlab-scanners-accessories"
      }
    ],
    "Cognex": [
      {
        "name": "Cognex Dataman 8700 Scanner",
        "url": "/collections/cognex-dataman-8700-scanner-accessories"
      },
      {
        "name": "Cognex MX1000 Scanner",
        "url": "/collections/cognex-mx1000-scanner-accessories"
      },
      {
        "name": "Cognex MX1100 Scanner",
        "url": "/collections/cognex-mx1100-scanner-accessories"
      },
      {
        "name": "Cognex MX1502 Scanner",
        "url": "/collections/cognex-mx1502-scanner-accessories"
      },
      {
        "name": "Cognex Scanner",
        "url": "/collections/cognex-scanners-accessories"
      }
    ],
    "Datalogic": [
      {
        "name": "Datalogic Gryphon 4200",
        "url": "/collections/datalogic-gryphon-4200-scanner-accessories"
      },
      {
        "name": "Datalogic Gryphon 4500",
        "url": "/collections/datalogic-gryphon-4500-scanner-accessories"
      },
      {
        "name": "Datalogic Joya Touch 22",
        "url": "/collections/datalogic-joya-touch-22-scanner-accessories"
      },
      {
        "name": "Datalogic Joya Touch/A6",
        "url": "/collections/datalogic-joya-touch-a6-scanner-accessories"
      },
      {
        "name": "Datalogic Memor 1",
        "url": "/collections/datalogic-memor-1-scanner-accessories"
      },
      {
        "name": "Datalogic Memor 10",
        "url": "/collections/datalogic-memor-10-scanner-accessories"
      },
      {
        "name": "Datalogic Memor 11",
        "url": "/collections/datalogic-memor-11-scanner-accessories"
      },
      {
        "name": "Datalogic Memor 12-17",
        "url": "/collections/datalogic-memor-12-17-scanner-accessories"
      },
      {
        "name": "Datalogic Memor 20",
        "url": "/collections/datalogic-memor-20-scanner-accessories"
      },
      {
        "name": "Datalogic Memor 30-35",
        "url": "/collections/datalogic-memor-30-35-scanner-accessories"
      },
      {
        "name": "Datalogic Memor K",
        "url": "/collections/datalogic-memor-k-scanner-accessories"
      },
      {
        "name": "Datalogic PowerScan 9100",
        "url": "/collections/datalogic-powerscan-9100-scanner-accessories"
      },
      {
        "name": "Datalogic PowerScan 9500",
        "url": "/collections/datalogic-powerscan-9500-scanner-accessories"
      },
      {
        "name": "Datalogic PowerScan 9600",
        "url": "/collections/datalogic-powerscan-9600-scanner-accessories"
      },
      {
        "name": "Datalogic QuickScan QBT2500",
        "url": "/collections/datalogic-quickscan-qbt2500-scanner-accessories"
      },
      {
        "name": "Datalogic QuickScan QM2500",
        "url": "/collections/datalogic-quickscan-qm2500-scanner-accessories"
      },
      {
        "name": "Datalogic Scanner",
        "url": "/collections/datalogic-scanners-accessories"
      },
      {
        "name": "Datalogic Skorpio X5",
        "url": "/collections/datalogic-skorpio-x5-scanner-accessories"
      }
    ],
    "Elo": [
      {
        "name": "Elo M50 Scanner",
        "url": "/collections/elo-m50-scanner-accessories"
      },
      {
        "name": "Elo M51 Mobile Computer",
        "url": "/collections/elo-m51-scanner-accessories"
      },
      {
        "name": "Elo M60 POS",
        "url": "/collections/elo-m60-scanner-accessories"
      },
      {
        "name": "Elo Scanner & Handheld",
        "url": "/collections/elo-scanners-accessories"
      }
    ],
    "Guardian": [
      {
        "name": "Guardian RFID",
        "url": "/collections/guardian-rfid-accessories"
      },
      {
        "name": "Guardian RFID Spartan 3 Case & Holster",
        "url": "/collections/guardian-spartan-3-rfid-accessories"
      }
    ],
    "Honeywell": [
      {
        "name": "Honeywell CK3",
        "url": "/collections/honeywell-ck3-scanner-accessories"
      },
      {
        "name": "Honeywell CK75",
        "url": "/collections/honeywell-ck75-scanner-accessories"
      },
      {
        "name": "Honeywell CT30 XP",
        "url": "/collections/honeywell-ct30-xp-scanner-accessories"
      },
      {
        "name": "Honeywell CT32 Scanner",
        "url": "/collections/honeywell-ct32-scanner-accessories"
      },
      {
        "name": "Honeywell CT37",
        "url": "/collections/honeywell-ct37-scanner-accessories"
      },
      {
        "name": "Honeywell CT45/45XP Scanner",
        "url": "/collections/honeywell-ct45-45xp-scanner-accessories"
      },
      {
        "name": "Honeywell CT47",
        "url": "/collections/honeywell-ct47-scanner-accessories"
      },
      {
        "name": "Honeywell CT60 XP",
        "url": "/collections/honeywell-ct60-xp-scanner-accessories"
      },
      {
        "name": "Honeywell CT70 Scanner",
        "url": "/collections/honeywell-ct70-scanner-accessories"
      },
      {
        "name": "Honeywell CW45",
        "url": "/collections/honeywell-cw45-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin 60S",
        "url": "/collections/honeywell-dolphin-60s-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin 70E",
        "url": "/collections/honeywell-dolphin-70e-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin 75/75E",
        "url": "/collections/honeywell-dolphin-75-75e-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin 99EX",
        "url": "/collections/honeywell-dolphin-99ex-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin 99GX",
        "url": "/collections/honeywell-dolphin-99gx-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CK62",
        "url": "/collections/honeywell-dolphin-ck62-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CK65",
        "url": "/collections/honeywell-dolphin-ck65-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CK67",
        "url": "/collections/honeywell-dolphin-ck67-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CN51",
        "url": "/collections/honeywell-dolphin-cn51-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CN75/CN75E",
        "url": "/collections/honeywell-dolphin-cn75-cn75e-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CN80 & CN80G",
        "url": "/collections/honeywell-dolphin-cn80-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CN85",
        "url": "/collections/honeywell-dolphin-cn85-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CT40",
        "url": "/collections/honeywell-dolphin-ct40-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CT40 XP",
        "url": "/collections/honeywell-dolphin-ct40-xp-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CT50/CT50H",
        "url": "/collections/honeywell-dolphin-ct50-ct50h-scanner-accessories"
      },
      {
        "name": "Honeywell Dolphin CT60",
        "url": "/collections/honeywell-dolphin-ct60-scanner-accessories"
      },
      {
        "name": "Honeywell EDA5S",
        "url": "/collections/honeywell-eda5s-scanner-accessories"
      },
      {
        "name": "Honeywell Granit 1910i",
        "url": "/collections/honeywell-granit-1910i-scanner-accessories"
      },
      {
        "name": "Honeywell Granit 1911i",
        "url": "/collections/honeywell-granit-1911i-scanner-accessories"
      },
      {
        "name": "Honeywell Granit 1981i",
        "url": "/collections/honeywell-granit-1981i-scanner-accessories"
      },
      {
        "name": "Honeywell Granit XP 1990iXLR",
        "url": "/collections/honeywell-granit-xp-1990ixlr-scanner-accessories"
      },
      {
        "name": "Honeywell Granit XP 1991iXLR",
        "url": "/collections/honeywell-granit-xp-1991ixlr-scanner-accessories"
      },
      {
        "name": "Honeywell IH21 UHF RFID Scanner",
        "url": "/collections/honeywell-ih21-scanner-accessories"
      },
      {
        "name": "Honeywell IH40 RFID Handheld Holster",
        "url": "/collections/honeywell-ih40-scanner-accessories"
      },
      {
        "name": "Honeywell IH45 RFID Scanner Holster",
        "url": "/collections/honeywell-ih45-scanner-accessories"
      },
      {
        "name": "Honeywell Intermec CK3R",
        "url": "/collections/honeywell-intermec-ck3r-scanner-accessories"
      },
      {
        "name": "Honeywell Intermec CK3X",
        "url": "/collections/honeywell-intermec-ck3x-scanner-accessories"
      },
      {
        "name": "Honeywell Scanner",
        "url": "/collections/honeywell-scanners-accessories"
      },
      {
        "name": "Honeywell ScanPal EDA50/EDA51",
        "url": "/collections/honeywell-scanpal-eda50-eda51-scanner-accessories"
      },
      {
        "name": "Honeywell ScanPal EDA51K",
        "url": "/collections/honeywell-scanpal-eda51k-scanner-accessories"
      },
      {
        "name": "Honeywell ScanPal EDA52",
        "url": "/collections/honeywell-scanpal-eda52-scanner-accessories"
      },
      {
        "name": "Honeywell ScanPal EDA56",
        "url": "/collections/honeywell-scanpal-eda56-scanner-accessories"
      },
      {
        "name": "Honeywell ScanPal EDA57",
        "url": "/collections/honeywell-scanpal-eda57-scanner-accessories"
      },
      {
        "name": "Honeywell ScanPal EDA60K Scanner",
        "url": "/collections/honeywell-scanpal-eda60k-scanner-accessories"
      },
      {
        "name": "Honeywell ScanPal EDA61K",
        "url": "/collections/honeywell-scanpal-eda61k-scanner-accessories"
      },
      {
        "name": "Honeywell Tecton",
        "url": "/collections/honeywell-tecton-scanner-accessories"
      },
      {
        "name": "Honeywell Voice A710x",
        "url": "/collections/honeywell-voice-a710x-scanner-accessories"
      },
      {
        "name": "Honeywell Voice A720x",
        "url": "/collections/honeywell-voice-a720x-scanner-accessories"
      },
      {
        "name": "Honeywell Voice A730x",
        "url": "/collections/honeywell-voice-a730x-scanner-accessories"
      },
      {
        "name": "Honeywell Voyager 1202G",
        "url": "/collections/honeywell-voyager-1202g-scanner-accessories"
      },
      {
        "name": "Honeywell Voyager 1602G",
        "url": "/collections/honeywell-voyager-1602g-scanner-accessories"
      },
      {
        "name": "Honeywell Voyager XP 1472g Holster",
        "url": "/collections/honeywell-voyager-xp-1472g-scanner-accessories"
      },
      {
        "name": "Honeywell Xenon Ultra 1960",
        "url": "/collections/honeywell-xenon-ultra-1960-scanner-accessories"
      },
      {
        "name": "Honeywell Xenon Ultra 1962",
        "url": "/collections/honeywell-xenon-ultra-1962-scanner-accessories"
      },
      {
        "name": "Honeywell Xenon XP 1952g",
        "url": "/collections/honeywell-xenon-xp-1952g-scanner-accessories"
      }
    ],
    "Intermec": [
      {
        "name": "Intermec CS40",
        "url": "/collections/intermec-cs40-scanner-accessories"
      },
      {
        "name": "Intermec Scanner",
        "url": "/collections/intermec-scanner-accessories"
      }
    ],
    "Janam": [
      {
        "name": "Janam Scanner",
        "url": "/collections/janam-scanners-accessories"
      },
      {
        "name": "Janam XG200 Scanner",
        "url": "/collections/janam-xg200-scanner-accessories"
      },
      {
        "name": "Janam XG4",
        "url": "/collections/janam-xg4-scanner-accessories"
      },
      {
        "name": "Janam XM2-RFID",
        "url": "/collections/janam-xm2-scanner-accessories"
      },
      {
        "name": "Janam XM5",
        "url": "/collections/janam-xm5-scanner-accessories"
      },
      {
        "name": "Janam XM75",
        "url": "/collections/janam-xm75-scanner-accessories"
      },
      {
        "name": "Janam XM75+",
        "url": "/collections/janam-xm75-plus-scanner-accessories"
      },
      {
        "name": "Janam XR2 RFID Reader",
        "url": "/collections/janam-xr2-scanner-accessories"
      },
      {
        "name": "Janam XT100",
        "url": "/collections/janam-xt100-scanner-accessories"
      },
      {
        "name": "Janam XT2",
        "url": "/collections/janam-xt2-scanner-accessories"
      },
      {
        "name": "Janam XT200",
        "url": "/collections/janam-xt200-scanner-accessories"
      },
      {
        "name": "Janam XT3",
        "url": "/collections/janam-xt3-scanner-accessories"
      },
      {
        "name": "Janam XT30",
        "url": "/collections/janam-xt30-scanner-accessories"
      },
      {
        "name": "Janam XT4 Scanner",
        "url": "/collections/janam-xt4-scanner-accessories"
      },
      {
        "name": "Janam XT40",
        "url": "/collections/janam-xt40-scanner-accessories"
      }
    ],
    "Keyence": [
      {
        "name": "Keyence BT-A500 Case & Holster",
        "url": "/collections/keyence-bt-a500-scanner-accessories"
      },
      {
        "name": "Keyence BT-A600 Scanner",
        "url": "/collections/keyence-bt-a600-scanner-accessories"
      },
      {
        "name": "Keyence BT-A700 Case & Holster",
        "url": "/collections/keyence-bt-a700-scanner-accessories"
      },
      {
        "name": "Keyence BT-W100 Scanner",
        "url": "/collections/keyence-bt-w100-scanner-accessories"
      },
      {
        "name": "Keyence BT-W70 Scanner",
        "url": "/collections/keyence-bt-w70-scanner-accessories"
      },
      {
        "name": "Keyence BT-W80 Scanner",
        "url": "/collections/keyence-bt-w80-scanner-accessories"
      },
      {
        "name": "Keyence DX-A400 Case & Holster",
        "url": "/collections/keyence-dx-a400-scanner-accessories"
      },
      {
        "name": "Keyence DX-A600 Case & Holster",
        "url": "/collections/keyence-dx-a600-scanner-accessories"
      },
      {
        "name": "Keyence DX-W600",
        "url": "/collections/keyence-dx-w600-scanner-accessories"
      },
      {
        "name": "Keyence HR-100 Case & Holster",
        "url": "/collections/keyence-hr-100-scanner-accessories"
      },
      {
        "name": "Keyence HR-X100WB Case & Holster",
        "url": "/collections/keyence-hr-x100wb-scanner-accessories"
      },
      {
        "name": "Keyence HR-X300WB Case & Holster",
        "url": "/collections/keyence-hr-x300wb-scanner-accessories"
      },
      {
        "name": "Keyence Scanner",
        "url": "/collections/keyence-scanners-accessories"
      }
    ],
    "Newland": [
      {
        "name": "Newland ME60 Case & Holster",
        "url": "/collections/newland-me60-scanner-accessories"
      },
      {
        "name": "Newland MT37 Case & Holster",
        "url": "/collections/newland-mt37-scanner-accessories"
      },
      {
        "name": "Newland MT65 Case & Holster",
        "url": "/collections/newland-mt65-scanner-accessories"
      },
      {
        "name": "Newland MT67 Sei",
        "url": "/collections/newland-mt67-sei-scanner-accessories"
      },
      {
        "name": "Newland MT90 Case & Holster",
        "url": "/collections/newland-mt90-scanner-accessories"
      },
      {
        "name": "Newland MT90 Pro Case & Holster",
        "url": "/collections/newland-mt90-pro-scanner-accessories"
      },
      {
        "name": "Newland MT93",
        "url": "/collections/newland-mt93-scanner-accessories"
      },
      {
        "name": "Newland MT95 Kambur Pro Scanner",
        "url": "/collections/newland-mt95-kambur-pro-scanner-accessories"
      },
      {
        "name": "Newland N510",
        "url": "/collections/newland-n510-scanner-accessories"
      },
      {
        "name": "Newland N7 Case & Holster",
        "url": "/collections/newland-n7-scanner-accessories"
      },
      {
        "name": "Newland N700",
        "url": "/collections/newland-n700-scanner-accessories"
      },
      {
        "name": "Newland N750",
        "url": "/collections/newland-n750-scanner-accessories"
      },
      {
        "name": "Newland N910 & N910 Pro",
        "url": "/collections/newland-n910-n910-pro-scanner-accessories"
      },
      {
        "name": "Newland N950",
        "url": "/collections/newland-n950-scanner-accessories"
      },
      {
        "name": "Newland NFT10 Case & Holster",
        "url": "/collections/newland-nft10-scanner-accessories"
      },
      {
        "name": "Newland NFT10 Pilot PRO",
        "url": "/collections/newland-nft10-pilot-pro-scanner-accessories"
      },
      {
        "name": "Newland Scanner",
        "url": "/collections/newland-scanners-accessories"
      }
    ],
    "Panasonic": [
      {
        "name": "Panasonic FZ-N1 Scanner",
        "url": "/collections/panasonic-toughbook-fz-n1-scanner-accessories"
      },
      {
        "name": "Panasonic Scanner",
        "url": "/collections/panasonic-scanners-accessories"
      },
      {
        "name": "Panasonic Toughbook FZ-T1",
        "url": "/collections/panasonic-toughbook-fz-t1-scanner-accessories"
      },
      {
        "name": "Panasonic Toughpad FZ-E1",
        "url": "/collections/panasonic-toughpad-fz-e1-scanner-accessories"
      },
      {
        "name": "Panasonic Toughpad FZ-X1",
        "url": "/collections/panasonic-toughpad-fz-x1-scanner-accessories"
      }
    ],
    "Unitech": [
      {
        "name": "Unitech EA500/EA500+",
        "url": "/collections/unitech-ea500-ea500-scanner-accessories"
      },
      {
        "name": "Unitech EA520",
        "url": "/collections/unitech-ea520-scanner-accessories"
      },
      {
        "name": "Unitech EA602",
        "url": "/collections/unitech-ea602-scanner-accessories"
      },
      {
        "name": "Unitech EA630",
        "url": "/collections/unitech-ea630-scanner-accessories"
      },
      {
        "name": "Unitech EA630T",
        "url": "/collections/unitech-ea630t-scanner-accessories"
      },
      {
        "name": "Unitech EA660",
        "url": "/collections/unitech-ea660-scanner-accessories"
      },
      {
        "name": "Unitech HT1 2D",
        "url": "/collections/unitech-ht1-2d-scanner-accessories"
      },
      {
        "name": "Unitech HT330",
        "url": "/collections/unitech-ht330-scanner-accessories"
      },
      {
        "name": "Unitech HT730/Plus",
        "url": "/collections/unitech-ht730-plus-scanner-accessories"
      },
      {
        "name": "Unitech MS822B",
        "url": "/collections/unitech-ms822b-scanner-accessories"
      },
      {
        "name": "Unitech MS836B",
        "url": "/collections/unitech-ms836b-scanner-accessories"
      },
      {
        "name": "Unitech MS838B",
        "url": "/collections/unitech-ms838b-scanner-accessories"
      },
      {
        "name": "Unitech MS851B",
        "url": "/collections/unitech-ms851b-scanner-accessories"
      },
      {
        "name": "Unitech MS852B",
        "url": "/collections/unitech-ms852b-scanner-accessories"
      },
      {
        "name": "Unitech MS852P",
        "url": "/collections/unitech-ms852p-scanner-accessories"
      },
      {
        "name": "Unitech PA700,V,MCA",
        "url": "/collections/unitech-pa700-v-mca-scanner-accessories"
      },
      {
        "name": "Unitech PA720/PA720 MCA",
        "url": "/collections/unitech-pa720-pa720-mca-scanner-accessories"
      },
      {
        "name": "Unitech PA726/PA726 MCA",
        "url": "/collections/unitech-pa726-pa726-mca-scanner-accessories"
      },
      {
        "name": "Unitech PA730/PA730V",
        "url": "/collections/unitech-pa730-pa730v-scanner-accessories"
      },
      {
        "name": "Unitech PA760",
        "url": "/collections/unitech-pa760-scanner-accessories"
      },
      {
        "name": "Unitech PA768",
        "url": "/collections/unitech-pa768-scanner-accessories"
      },
      {
        "name": "Unitech RP902",
        "url": "/collections/unitech-rp902-scanner-accessories"
      },
      {
        "name": "Unitech Scanner",
        "url": "/collections/unitech-scanners-accessories"
      }
    ],
    "Urovo": [
      {
        "name": "Urovo DT40",
        "url": "/collections/urovo-dt40-scanner-accessories"
      },
      {
        "name": "Urovo DT50",
        "url": "/collections/urovo-dt50-scanner-accessories"
      },
      {
        "name": "Urovo i6300",
        "url": "/collections/urovo-i6300-scanner-accessories"
      },
      {
        "name": "Urovo i6310",
        "url": "/collections/urovo-i6310-scanner-accessories"
      },
      {
        "name": "Urovo i9000s",
        "url": "/collections/urovo-i9000s-pos-accessories"
      },
      {
        "name": "Urovo i9100",
        "url": "/collections/urovo-i9100-pos-accessories"
      },
      {
        "name": "Urovo Scanner",
        "url": "/collections/urovo-scanners-accessories"
      }
    ],
    "WASP": [
      {
        "name": "WASP DR2 2D",
        "url": "/collections/wasp-dr2-2d-scanner-accessories"
      },
      {
        "name": "WASP DR3 2D",
        "url": "/collections/wasp-dr3-2d-scanner-accessories"
      },
      {
        "name": "WASP DR4 2D",
        "url": "/collections/wasp-dr4-2d-scanner-accessories"
      },
      {
        "name": "WASP DR5 2D",
        "url": "/collections/wasp-dr5-2d-scanner-accessories"
      },
      {
        "name": "WASP DR6",
        "url": "/collections/wasp-dr6-scanner-accessories"
      },
      {
        "name": "WASP HC1",
        "url": "/collections/wasp-hc1-scanner-accessories"
      },
      {
        "name": "Wasp Mobile Computer",
        "url": "/collections/wasp-scanners-accessories"
      },
      {
        "name": "WASP WLR8950",
        "url": "/collections/wasp-wlr8950-scanner-accessories"
      },
      {
        "name": "WASP WWS550i",
        "url": "/collections/wasp-wws550i-scanner-accessories"
      },
      {
        "name": "WASP WWS650",
        "url": "/collections/wasp-wws650-scanner-accessories"
      },
      {
        "name": "WASP WWS800",
        "url": "/collections/wasp-wws800-scanner-accessories"
      }
    ],
    "Zebra": [
      {
        "name": "Zebra",
        "url": "/collections/zebra-scanners-accessories"
      },
      {
        "name": "Zebra CS3000",
        "url": "/collections/zebra-cs3000-scanner-accessories"
      },
      {
        "name": "Zebra CS4070",
        "url": "/collections/zebra-symbol-cs4070-scanner-accessories"
      },
      {
        "name": "Zebra CS60",
        "url": "/collections/zebra-cs60-scanner-accessories"
      },
      {
        "name": "Zebra DS2208",
        "url": "/collections/zebra-ds2208-scanner-accessories"
      },
      {
        "name": "Zebra DS2278",
        "url": "/collections/zebra-ds2278-scanner-accessories"
      },
      {
        "name": "Zebra DS3600",
        "url": "/collections/zebra-ds3600-scanner-accessories"
      },
      {
        "name": "Zebra DS4608",
        "url": "/collections/zebra-ds4608-scanner-accessories"
      },
      {
        "name": "Zebra DS8100",
        "url": "/collections/zebra-ds8100-scanner-accessories"
      },
      {
        "name": "Zebra DS8178",
        "url": "/collections/zebra-ds8178-scanner-accessories"
      },
      {
        "name": "Zebra EC50",
        "url": "/collections/zebra-ec50-scanner-accessories"
      },
      {
        "name": "Zebra EC55",
        "url": "/collections/zebra-ec55-scanner-accessories"
      },
      {
        "name": "Zebra EM45 RFID",
        "url": "/collections/zebra-em45-scanner-accessories"
      },
      {
        "name": "Zebra HC20",
        "url": "/collections/zebra-hc20-scanner-accessories"
      },
      {
        "name": "Zebra HC25",
        "url": "/collections/zebra-hc25-scanner-accessories"
      },
      {
        "name": "Zebra HC50",
        "url": "/collections/zebra-hc50-scanner-accessories"
      },
      {
        "name": "Zebra HC55",
        "url": "/collections/zebra-hc55-scanner-accessories"
      },
      {
        "name": "Zebra LI2208",
        "url": "/collections/zebra-li2208-scanner-accessories"
      },
      {
        "name": "Zebra LI3600",
        "url": "/collections/zebra-li3600-scanner-accessories"
      },
      {
        "name": "Zebra LS2208",
        "url": "/collections/zebra-ls2208-scanner-accessories"
      },
      {
        "name": "Zebra M60",
        "url": "/collections/zebra-m60-scanner-accessories"
      },
      {
        "name": "Zebra MC2200/2700",
        "url": "/collections/zebra-mc2200-2700-scanner-accessories"
      },
      {
        "name": "Zebra MC3200",
        "url": "/collections/zebra-mc3200-scanner-accessories"
      },
      {
        "name": "Zebra MC3300",
        "url": "/collections/zebra-mc3300-scanner-accessories"
      },
      {
        "name": "Zebra MC3330xR Scanner",
        "url": "/collections/zebra-mc3330xr-scanner-accessories"
      },
      {
        "name": "Zebra MC3390xR",
        "url": "/collections/zebra-mc3390xr-scanner-accessories"
      },
      {
        "name": "Zebra MC3400",
        "url": "/collections/zebra-mc3400-scanner-accessories"
      },
      {
        "name": "Zebra MC3450 Scanner",
        "url": "/collections/zebra-mc3450-scanner-accessories"
      },
      {
        "name": "Zebra MC40/45",
        "url": "/collections/zebra-mc40-45-scanner-accessories"
      },
      {
        "name": "Zebra MC9060",
        "url": "/collections/zebra-mc9060-scanner-accessories"
      },
      {
        "name": "Zebra MC9090",
        "url": "/collections/zebra-mc9090-scanner-accessories"
      },
      {
        "name": "Zebra MC9190 Scanner",
        "url": "/collections/zebra-mc9190-scanner-accessories"
      },
      {
        "name": "Zebra MC9200",
        "url": "/collections/zebra-mc9200-scanner-accessories"
      },
      {
        "name": "Zebra MC9300",
        "url": "/collections/zebra-mc9300-scanner-accessories"
      },
      {
        "name": "Zebra MC9400",
        "url": "/collections/zebra-mc9400-scanner-accessories"
      },
      {
        "name": "Zebra MC9401 Scanner",
        "url": "/collections/zebra-mc9401-scanner-accessories"
      },
      {
        "name": "Zebra MC9450",
        "url": "/collections/zebra-mc9450-scanner-accessories"
      },
      {
        "name": "Zebra MC9596",
        "url": "/collections/zebra-mc9596-scanner-accessories"
      },
      {
        "name": "Zebra Motorola Zebra MC9500",
        "url": "/collections/motorola-zebra-mc9500-scanner-accessories"
      },
      {
        "name": "Zebra PS20",
        "url": "/collections/zebra-ps20-scanner-accessories-1"
      },
      {
        "name": "Zebra PS20 Plus",
        "url": "/collections/zebra-ps20-scanner-accessories"
      },
      {
        "name": "Zebra PS30",
        "url": "/collections/zebra-ps30-scanner-accessories"
      },
      {
        "name": "Zebra RFD2000",
        "url": "/collections/zebra-rfd2000-scanner-accessories"
      },
      {
        "name": "Zebra RFD40",
        "url": "/collections/zebra-rfd40-scanner-accessories"
      },
      {
        "name": "Zebra Scanner Holder",
        "url": "/collections/zebra-scanner-holder-for-forklift"
      },
      {
        "name": "Zebra TC15",
        "url": "/collections/zebra-tc15-scanner-accessories"
      },
      {
        "name": "Zebra TC21",
        "url": "/collections/zebra-tc21-scanner-accessories"
      },
      {
        "name": "Zebra TC22",
        "url": "/collections/zebra-tc22-scanner-accessories"
      },
      {
        "name": "Zebra TC22R RFID",
        "url": "/collections/zebra-tc22r-scanner-accessories"
      },
      {
        "name": "Zebra TC26",
        "url": "/collections/zebra-tc26-scanner-accessories"
      },
      {
        "name": "Zebra TC27",
        "url": "/collections/zebra-tc27-scanner-accessories"
      },
      {
        "name": "Zebra TC501",
        "url": "/collections/zebra-tc501-scanner-accessories"
      },
      {
        "name": "Zebra TC51",
        "url": "/collections/zebra-tc51-scanner-accessories"
      },
      {
        "name": "Zebra TC52 & TC52x",
        "url": "/collections/zebra-tc52-scanner-accessories"
      },
      {
        "name": "Zebra TC52ax",
        "url": "/collections/zebra-tc52ax-scanner-accessories"
      },
      {
        "name": "Zebra TC53",
        "url": "/collections/zebra-tc53-scanner-accessories"
      },
      {
        "name": "Zebra TC55",
        "url": "/collections/zebra-tc55-scanner-accessories"
      },
      {
        "name": "Zebra TC56",
        "url": "/collections/zebra-tc56-scanner-accessories"
      },
      {
        "name": "Zebra TC57 & TC57x",
        "url": "/collections/zebra-tc57-tc57x-scanner-accessories"
      },
      {
        "name": "Zebra TC58",
        "url": "/collections/zebra-tc58-scanner-accessories"
      },
      {
        "name": "Zebra TC70 & TC70x",
        "url": "/collections/zebra-tc70-tc70x-scanner-accessories"
      },
      {
        "name": "Zebra TC701",
        "url": "/collections/zebra-tc701-scanner-accessories"
      },
      {
        "name": "Zebra TC72",
        "url": "/collections/zebra-tc72-scanner-accessories"
      },
      {
        "name": "Zebra TC73",
        "url": "/collections/zebra-tc73-scanner-accessories"
      },
      {
        "name": "Zebra TC75 & TC75x",
        "url": "/collections/zebra-tc75-tc75x-scanner-accessories"
      },
      {
        "name": "Zebra TC77",
        "url": "/collections/zebra-tc77-scanner-accessories"
      },
      {
        "name": "Zebra TC78",
        "url": "/collections/zebra-tc78-scanner-accessories"
      },
      {
        "name": "Zebra TC8000",
        "url": "/collections/zebra-tc8000-scanner-accessories"
      },
      {
        "name": "Zebra TC8300",
        "url": "/collections/zebra-tc8300-scanner-accessories"
      },
      {
        "name": "Zebra TN28 Scanner",
        "url": "/collections/zebra-tn28-scanner-accessories"
      }
    ]
  },
  "tablets": {
    "Apple": [
      {
        "name": "Apple iPad",
        "url": "/collections/apple-ipad-tablets-accessories"
      },
      {
        "name": "Apple iPad 10th Generation",
        "url": "/collections/apple-ipad-10th-generation-tablet-accessories"
      },
      {
        "name": "Apple iPad 11th Generation",
        "url": "/collections/apple-ipad-11th-generation-tablet-accessories"
      },
      {
        "name": "Apple iPad 8th Generation",
        "url": "/collections/apple-ipad-8th-generation-tablet-accessories"
      },
      {
        "name": "Apple iPad 9th Generation",
        "url": "/collections/apple-ipad-9th-generation-tablet-accessories"
      },
      {
        "name": "Apple iPad Air",
        "url": "/collections/apple-ipad-air-tablet-accessories"
      },
      {
        "name": "Apple iPad Pro",
        "url": "/collections/apple-ipad-pro-tablet-accessories"
      }
    ],
    "Honeywell": [
      {
        "name": "Honeywell Tablet",
        "url": "/collections/honeywell-tablets-accessories"
      }
    ],
    "Lenovo": [
      {
        "name": "Lenovo Chromebook Duet 11",
        "url": "/collections/lenovo-chromebook-duet-11-tablet-accessories"
      },
      {
        "name": "Lenovo Tab M10",
        "url": "/collections/lenovo-tab-m10-tablet-accessories"
      },
      {
        "name": "Lenovo Tablet",
        "url": "/collections/lenovo-tablets-accessories"
      }
    ],
    "Microsoft": [
      {
        "name": "Microsoft Tablet",
        "url": "/collections/microsoft-tablets-accessories"
      }
    ],
    "Rhino": [
      {
        "name": "Rhino C10 Tablet Case, Mounts",
        "url": "/collections/rhino-c10-tablet-accessories"
      },
      {
        "name": "Rhino T100 Tablet Case, Mounts",
        "url": "/collections/rhino-t100-tablet-accessories"
      },
      {
        "name": "Rhino T105 Tablet Case, Mounts",
        "url": "/collections/rhino-t105-tablet-accessories"
      },
      {
        "name": "Rhino T8 Tablet Case, Mounts",
        "url": "/collections/rhino-t8-tablet-accessories"
      },
      {
        "name": "Rhino T80 Tablet Case, Mounts",
        "url": "/collections/rhino-t80-tablet-accessories"
      },
      {
        "name": "Rhino Tablet",
        "url": "/collections/rhino-tablets-accessories"
      }
    ],
    "Samsung": [
      {
        "name": "Samsung Galaxy Tab A",
        "url": "/collections/samsung-galaxy-tab-a-tablet-accessories"
      },
      {
        "name": "Samsung Galaxy Tab Active Pro",
        "url": "/collections/samsung-galaxy-tab-active-pro-tablet-accessories"
      },
      {
        "name": "Samsung Galaxy Tab Active3",
        "url": "/collections/samsung-galaxy-tab-active3-tablet-accessories"
      },
      {
        "name": "Samsung Galaxy Tab Active4 Pro",
        "url": "/collections/samsung-galaxy-tab-active4-pro-tablet-accessories"
      },
      {
        "name": "Samsung Galaxy Tab Active5",
        "url": "/collections/samsung-galaxy-tab-active5-tablet-accessories"
      },
      {
        "name": "Samsung Galaxy Tab Active5 Pro",
        "url": "/collections/samsung-galaxy-tab-active5-pro-tablet-accessories"
      },
      {
        "name": "Samsung Galaxy Tablet",
        "url": "/collections/samsung-tablets-accessories"
      }
    ],
    "Zebra": [
      {
        "name": "Zebra ET40 Tablet Case, Holster",
        "url": "/collections/zebra-et40-tablet-accessories"
      },
      {
        "name": "Zebra ET401 Tablet Case, Mount",
        "url": "/collections/zebra-et401-tablet-accessories"
      },
      {
        "name": "Zebra ET45 Tablet Case, Holster",
        "url": "/collections/zebra-et45-tablet-accessories"
      },
      {
        "name": "Zebra ET51",
        "url": "/collections/zebra-et51-tablet-accessories"
      },
      {
        "name": "Zebra ET56",
        "url": "/collections/zebra-et56-tablet-accessories"
      },
      {
        "name": "Zebra ET60 Case, Holster",
        "url": "/collections/zebra-et60-tablet-accessories"
      },
      {
        "name": "Zebra ET65 Case, Holster",
        "url": "/collections/zebra-et65-tablet-accessories"
      },
      {
        "name": "Zebra Tablet",
        "url": "/collections/zebra-tablets-accessories"
      },
      {
        "name": "Zebra XPAD L10 Case, Holster",
        "url": "/collections/zebra-xpad-l10-tablet-accessories"
      },
      {
        "name": "Zebra XSLATE L10 Case, Holster",
        "url": "/collections/zebra-xslate-l10-tablet-accessories"
      },
      {
        "name": "Zebra XSLATE L10ax Case, Holster",
        "url": "/collections/zebra-xslate-l10ax-tablet-accessories"
      }
    ]
  },
  "printers": {
    "Bixolon": [
      {
        "name": "Bixolon Mobile Printer",
        "url": "/collections/bixolon-printers-accessories"
      },
      {
        "name": "BIXOLON SRP-350III Receipt Printer Shelf, Mount",
        "url": "/collections/bixolon-srp-350iii-printer-accessories"
      }
    ],
    "Brother": [
      {
        "name": "Brother Go RJ-2035B Printer",
        "url": "/collections/brother-go-rj-2035b-printer-accessories"
      },
      {
        "name": "Brother Go RJ-2055WB Printer",
        "url": "/collections/brother-go-rj-2055wb-printer-accessories"
      },
      {
        "name": "Brother Portable Printer",
        "url": "/collections/brother-printers-accessories"
      },
      {
        "name": "Brother RJ-2031 Printer",
        "url": "/collections/brother-rj-2031-printer-accessories"
      },
      {
        "name": "Brother RJ-2050 Printer",
        "url": "/collections/brother-rj-2050-printer-accessories"
      },
      {
        "name": "Brother RJ-2140 Printer",
        "url": "/collections/brother-rj-2140-printer-accessories"
      },
      {
        "name": "Brother RJ-2150 Printer",
        "url": "/collections/brother-rj-2150-printer-accessories"
      },
      {
        "name": "Brother RJ-3035B Printer",
        "url": "/collections/brother-rj-3035b-printer-accessories"
      },
      {
        "name": "Brother RJ-3050 Printer",
        "url": "/collections/brother-rj-3050-printer-accessories"
      },
      {
        "name": "Brother RJ-3050Ai Printer",
        "url": "/collections/brother-rj-3050ai-printer-accessories"
      },
      {
        "name": "Brother RJ-3055WB Printer",
        "url": "/collections/brother-rj-3055wb-printer-accessories"
      },
      {
        "name": "Brother RJ-3150 Printer",
        "url": "/collections/brother-rj-3150-printer-accessories"
      },
      {
        "name": "Brother RJ-3150Ai Printer",
        "url": "/collections/brother-rj-3150ai-printer-accessories"
      },
      {
        "name": "Brother RJ-3230BL Printer",
        "url": "/collections/brother-rj-3230bl-printer-accessories"
      },
      {
        "name": "Brother RJ-3250WB Printer",
        "url": "/collections/brother-rj-3250wb-printer-accessories"
      },
      {
        "name": "Brother RJ-4040 Printer",
        "url": "/collections/brother-rj-4040-printer-accessories"
      },
      {
        "name": "Brother RJ-4230B Printer",
        "url": "/collections/brother-rj-4230b-printer-accessories"
      },
      {
        "name": "Brother RJ-4230BL Printer",
        "url": "/collections/brother-rj-4230bl-printer-accessories"
      },
      {
        "name": "Brother RJ-4250WB Printer",
        "url": "/collections/brother-rj-4250wb-printer-accessories"
      }
    ],
    "Citizen": [
      {
        "name": "Citizen Mobile Printer",
        "url": "/collections/citizen-printers-accessories"
      }
    ],
    "Epson": [
      {
        "name": "Epson Mobile Printer",
        "url": "/collections/epson-printers-accessories"
      },
      {
        "name": "Epson Mobilink P60II Printer",
        "url": "/collections/epson-mobilink-p60ii-printer-accessories"
      },
      {
        "name": "Epson Mobilink P80 Printer",
        "url": "/collections/epson-mobilink-p80-printer-accessories"
      },
      {
        "name": "Epson Mobilink TM-P20II Printer",
        "url": "/collections/epson-mobilink-tm-p20ii-printer-accessories"
      },
      {
        "name": "Epson Mobilink TM-P80II Plus Printer",
        "url": "/collections/epson-mobilink-tm-p80ii-plus-printer-accessories"
      },
      {
        "name": "Epson Mobilink TM-P80II Printer",
        "url": "/collections/epson-mobilink-tm-p80ii-printer-accessories"
      },
      {
        "name": "Epson TM-T88 Kitchen Receipt Printer Shelf, Mount",
        "url": "/collections/epson-tm-t88-printer-accessories"
      },
      {
        "name": "Epson TM-T88V Impact Printer Shelf, Mount",
        "url": "/collections/epson-tm-t88v-printer-accessories"
      },
      {
        "name": "Epson TM-T88VI Kitchen Printer Shelf, Mount",
        "url": "/collections/epson-tm-t88vi-printer-accessories"
      },
      {
        "name": "Epson TM-U220 Kitchen Printer Shelf, Mount",
        "url": "/collections/epson-tm-u220-printer-accessories"
      },
      {
        "name": "Epson TM-U220B Impact Printer Shelf, Mount",
        "url": "/collections/epson-tm-u220b-printer-accessories"
      },
      {
        "name": "Epson TM-U220D Kitchen Receipt Printer Shelf, Mount",
        "url": "/collections/epson-tm-u220d-printer-accessories"
      },
      {
        "name": "Epson TM-U300 Kitchen Printer Shelf, Mount",
        "url": "/collections/epson-tm-u300-printer-accessories"
      }
    ],
    "Honeywell": [
      {
        "name": "Honeywell Intermec PB50/PB51 Printer",
        "url": "/collections/honeywell-intermec-pb50-pb51-printer-accessories"
      },
      {
        "name": "Honeywell PB22 Printer",
        "url": "/collections/honeywell-pb22-printer-accessories"
      },
      {
        "name": "Honeywell PB32 Printer",
        "url": "/collections/honeywell-pb32-printer-accessories"
      },
      {
        "name": "Honeywell Printer",
        "url": "/collections/honeywell-printers-accessories"
      },
      {
        "name": "Honeywell RL3e Printer",
        "url": "/collections/honeywell-rl3e-printer-accessories"
      },
      {
        "name": "Honeywell RL4e Printer",
        "url": "/collections/honeywell-rl4e-printer-accessories"
      },
      {
        "name": "Honeywell RP2f Printer",
        "url": "/collections/honeywell-rp2f-printer-accessories"
      },
      {
        "name": "Honeywell RP4f Printer",
        "url": "/collections/honeywell-rp4f-printer-accessories"
      }
    ],
    "Printronix": [
      {
        "name": "Printronix M4L2 Mobile Printer",
        "url": "/collections/printronix-m4l2-printer-accessories"
      },
      {
        "name": "Printronix Mobile Printer",
        "url": "/collections/printronix-printers-accessories"
      }
    ],
    "Seiko": [
      {
        "name": "Seiko Printer",
        "url": "/collections/seiko-printers-accessories"
      },
      {
        "name": "SEIKO SII RP-E10 POS Printer Shelf, Mount",
        "url": "/collections/seiko-sii-rp-e10-printer-accessories"
      },
      {
        "name": "SEIKO SII RP-E11 POS Printer Shelf, Mount",
        "url": "/collections/seiko-sii-rp-e11-printer-accessories"
      },
      {
        "name": "SEIKO SII RP-F10 POS Receipt Printer Shelf, Mount",
        "url": "/collections/seiko-sii-rp-f10-printer-accessories"
      },
      {
        "name": "SEIKO SII RP-G10 POS Receipt Printer Shelf, Mount",
        "url": "/collections/seiko-sii-rp-g10-printer-accessories"
      },
      {
        "name": "Seiko SII SLP-720RT Printer Shelf, Mount",
        "url": "/collections/seiko-sii-slp-720rt-printer-accessories"
      },
      {
        "name": "Seiko SII SLP-721RT Printer Shelf, Mount",
        "url": "/collections/seiko-sii-slp-721rt-printer-accessories"
      },
      {
        "name": "Seiko SII SLP620 Printer Shelf, Mount",
        "url": "/collections/seiko-sii-slp620-printer-accessories"
      },
      {
        "name": "Seiko SII SLP650 Printer Shelf, Mount",
        "url": "/collections/seiko-sii-slp650-printer-accessories"
      },
      {
        "name": "Seiko SII SLP850 Printer Shelf, Mount",
        "url": "/collections/seiko-sii-slp850-printer-accessories"
      }
    ],
    "Star Micronics": [
      {
        "name": "Star Micronics Mobile Printer",
        "url": "/collections/star-micronics-printers-accessories"
      },
      {
        "name": "Star Micronics SP500 Kitchen Printer Shelf, Mount",
        "url": "/collections/star-micronics-sp500-printer-accessories"
      },
      {
        "name": "Star Micronics SP512 Impact Printer Shelf, Mount",
        "url": "/collections/star-micronics-sp512-printer-accessories"
      },
      {
        "name": "Star Micronics SP542 Impact Printer Shelf, Mount",
        "url": "/collections/star-micronics-sp542-printer-accessories"
      },
      {
        "name": "Star Micronics SP700 Kitchen Printer Shelf, Mount",
        "url": "/collections/star-micronics-sp700-printer-accessories"
      },
      {
        "name": "Star Micronics SP712 Impact Printer Shelf, Mount",
        "url": "/collections/star-micronics-sp712-printer-accessories"
      },
      {
        "name": "Star Micronics SP742 Impact Printer Shelf, Mount",
        "url": "/collections/star-micronics-sp742-printer-accessories"
      },
      {
        "name": "Star Micronics TSP143III Impact Printer Shelf, Mount",
        "url": "/collections/star-micronics-tsp143iii-printer-accessories"
      }
    ],
    "TSC": [
      {
        "name": "TSC Alpha-40L Mobile Printer",
        "url": "/collections/tsc-alpha-40l-printer-accessories"
      },
      {
        "name": "TSC Mobile Printer",
        "url": "/collections/tsc-printers-accessories"
      }
    ],
    "Zebra": [
      {
        "name": "Zebra GC420D Printer Shelf, Mount",
        "url": "/collections/zebra-gc420d-printer-accessories"
      },
      {
        "name": "Zebra GC420T Printer Shelf, Mount",
        "url": "/collections/zebra-gc420t-printer-accessories"
      },
      {
        "name": "Zebra GK420D Printer Shelf, Mount",
        "url": "/collections/zebra-gk420d-printer-accessories"
      },
      {
        "name": "Zebra GK420T Printer Shelf, Mount",
        "url": "/collections/zebra-gk420t-printer-accessories"
      },
      {
        "name": "Zebra GX420D Printer Shelf, Mount",
        "url": "/collections/zebra-gx420d-printer-accessories"
      },
      {
        "name": "Zebra GX420T Printer Shelf, Mount",
        "url": "/collections/zebra-gx420t-printer-accessories"
      },
      {
        "name": "Zebra GX430T Printer Shelf, Mount",
        "url": "/collections/zebra-gx430t-printer-accessories"
      },
      {
        "name": "Zebra LP 2442 Printer Shelf, Mount",
        "url": "/collections/zebra-lp-2442-printer-accessories"
      },
      {
        "name": "Zebra LP 2443 Printer Shelf, Mount",
        "url": "/collections/zebra-lp-2443-printer-accessories"
      },
      {
        "name": "Zebra LP 2642 Printer Shelf, Mount",
        "url": "/collections/zebra-lp-2642-printer-accessories"
      },
      {
        "name": "Zebra LP 2742 Printer Shelf, Mount",
        "url": "/collections/zebra-lp-2742-printer-accessories"
      },
      {
        "name": "Zebra LP 2824 Printer Shelf, Mount",
        "url": "/collections/zebra-lp-2824-printer-accessories"
      },
      {
        "name": "Zebra LP 2844 Printer Shelf, Mount",
        "url": "/collections/zebra-lp-2844-printer-accessories"
      },
      {
        "name": "Zebra LP 3642 Printer Shelf, Mount",
        "url": "/collections/zebra-lp-3642-printer-accessories"
      },
      {
        "name": "Zebra LP 3742 Printer Shelf, Mount",
        "url": "/collections/zebra-lp-3742-printer-accessories"
      },
      {
        "name": "Zebra Printer",
        "url": "/collections/zebra-printers-accessories"
      },
      {
        "name": "Zebra QLn220 Printer",
        "url": "/collections/zebra-qln220-printer-accessories"
      },
      {
        "name": "Zebra QLn320 Printer",
        "url": "/collections/zebra-qln320-printer-accessories"
      },
      {
        "name": "Zebra QLN420 Printer",
        "url": "/collections/zebra-qln420-printer-accessories"
      },
      {
        "name": "Zebra R402 Printer Shelf, Mount",
        "url": "/collections/zebra-r402-printer-accessories"
      },
      {
        "name": "Zebra TLP2844 Printer Shelf, Mount",
        "url": "/collections/zebra-tlp2844-printer-accessories"
      },
      {
        "name": "Zebra TLP3844-Z Printer Shelf, Mount",
        "url": "/collections/zebra-tlp3844-z-printer-accessories"
      },
      {
        "name": "Zebra ZD220 Printer Shelf, Mount",
        "url": "/collections/zebra-zd220-printer-accessories"
      },
      {
        "name": "Zebra ZD230 Printer Shelf, Mount",
        "url": "/collections/zebra-zd230-printer-accessories"
      },
      {
        "name": "Zebra ZD411 Printer Shelf, Mount",
        "url": "/collections/zebra-zd411-printer-accessories"
      },
      {
        "name": "Zebra ZD421 Printer Shelf, Mount",
        "url": "/collections/zebra-zd421-printer-accessories"
      },
      {
        "name": "Zebra ZD621 Printer Shelf, Mount",
        "url": "/collections/zebra-zd621-printer-accessories"
      },
      {
        "name": "Zebra ZP450 Printer Shelf, Mount",
        "url": "/collections/zebra-zp450-printer-accessories"
      },
      {
        "name": "Zebra ZQ110 Printer",
        "url": "/collections/zebra-zq110-printer-accessories"
      },
      {
        "name": "Zebra ZQ120 Printer",
        "url": "/collections/zebra-zq120-printer-accessories"
      },
      {
        "name": "Zebra ZQ220 Plus Mobile Printer Holster, Case",
        "url": "/collections/zebra-zq220-printer-accessories"
      },
      {
        "name": "Zebra ZQ310/Plus Printer",
        "url": "/collections/zebra-zq310-plus-printer-accessories"
      },
      {
        "name": "Zebra ZQ320/Plus Mobile Printer Holster",
        "url": "/collections/zebra-zq320-printer-accessories"
      },
      {
        "name": "Zebra ZQ510 Printer",
        "url": "/collections/zebra-zq510-printer-accessories"
      },
      {
        "name": "Zebra ZQ511 Mobile Printer",
        "url": "/collections/zebra-zq511-printer-accessories"
      },
      {
        "name": "Zebra ZQ520 Mobile Printer",
        "url": "/collections/zebra-zq520-printer-accessories"
      },
      {
        "name": "Zebra ZQ521 Mobile Printer",
        "url": "/collections/zebra-zq521-printer-accessories"
      },
      {
        "name": "Zebra ZQ610 Plus Mobile Printer Holster",
        "url": "/collections/zebra-zq610-plus-printer-accessories"
      },
      {
        "name": "Zebra ZQ620 Plus Mobile Printer",
        "url": "/collections/zebra-zq620-plus-printer-accessories"
      },
      {
        "name": "Zebra ZQ630 Plus Printer",
        "url": "/collections/zebra-zq630-plus-printer-accessories"
      },
      {
        "name": "Zebra ZR111 Printer",
        "url": "/collections/zebra-zr111-printer-accessories"
      },
      {
        "name": "Zebra ZR118 Printer",
        "url": "/collections/zebra-zr118-printer-accessories"
      },
      {
        "name": "Zebra ZR138 Mobile Printer",
        "url": "/collections/zebra-zr138-printer-accessories"
      }
    ]
  },
  "radios": {
    "BaoFeng": [
      {
        "name": "BaoFeng BF-888S Two-Way Radio",
        "url": "/collections/baofeng-bf-888s-radio-accessories"
      },
      {
        "name": "BaoFeng BF-F8HP Two-Way Radio",
        "url": "/collections/baofeng-bf-f8hp-radio-accessories"
      },
      {
        "name": "Baofeng Radio",
        "url": "/collections/baofeng-radios-accessories"
      },
      {
        "name": "BaoFeng UV-82HP Two-Way Radio",
        "url": "/collections/baofeng-uv-82hp-radio-accessories"
      }
    ],
    "Cobra": [
      {
        "name": "Cobra PX650 Two-Way Radio",
        "url": "/collections/cobra-px650-radio-accessories"
      },
      {
        "name": "Cobra Radio",
        "url": "/collections/cobra-radios-accessories"
      }
    ],
    "DeWalt": [
      {
        "name": "DEWALT DXFRS300 Two-Way Radio",
        "url": "/collections/dewalt-dxfrs300-radio-accessories"
      },
      {
        "name": "DEWALT DXFRS800 Two-Way Radio",
        "url": "/collections/dewalt-dxfrs800-radio-accessories"
      },
      {
        "name": "DEWALT Two-Way Radio",
        "url": "/collections/dewalt-radios-accessories"
      }
    ],
    "Icom": [
      {
        "name": "Icom Radio",
        "url": "/collections/icom-radios-accessories"
      }
    ],
    "Kenwood": [
      {
        "name": "Kenwood NX-1200 Two-Way Radio",
        "url": "/collections/kenwood-nx-1200-radio-accessories"
      },
      {
        "name": "Kenwood NX-1300 Two-Way Radio",
        "url": "/collections/kenwood-nx-1300du-radio-accessories"
      },
      {
        "name": "Kenwood NX-200 Two-Way Radio",
        "url": "/collections/kenwood-nx-200-radio-accessories"
      },
      {
        "name": "Kenwood NX-300 Two-Way Radio",
        "url": "/collections/kenwood-nx-300-radio-accessories"
      },
      {
        "name": "Kenwood PKT-03 Case & Holster",
        "url": "/collections/kenwood-pkt-03-radio-accessories"
      },
      {
        "name": "Kenwood PKT-23 Case & Holster",
        "url": "/collections/kenwood-pkt-23-radio-accessories"
      },
      {
        "name": "Kenwood ProTalk NX-P500 Case & Holster",
        "url": "/collections/kenwood-protalk-nx-p500-radio-accessories"
      },
      {
        "name": "Kenwood TK-5220/5320 Two-Way Radio",
        "url": "/collections/kenwood-tk-5220-5320-radio-accessories"
      },
      {
        "name": "Kenwood Two-Way Radio",
        "url": "/collections/kenwood-radios-accessories"
      }
    ],
    "L3 Harris": [
      {
        "name": "L3 Harris L3Harris Radio",
        "url": "/collections/l3-harris-radios-accessories"
      },
      {
        "name": "L3 Harris L3Harris XL Connect 95P Two-Way Radio",
        "url": "/collections/l3-harris-xl-connect-95p-radio-accessories"
      },
      {
        "name": "L3 Harris L3Harris XL EXTREME 400 Two-Way Radio",
        "url": "/collections/l3-harris-xl-extreme-400-radio-accessories"
      },
      {
        "name": "L3 Harris XL-150P Two-Way Radio",
        "url": "/collections/l3-harris-xl-150p-radio-accessories"
      },
      {
        "name": "L3 Harris XL-185P Two-Way Radio",
        "url": "/collections/l3-harris-xl-185p-radio-accessories"
      }
    ],
    "Midland": [
      {
        "name": "Midland BR200 Two-Way Radio",
        "url": "/collections/midland-br200-radio-accessories"
      },
      {
        "name": "Midland GXT1050VP4 Two-Way Radio",
        "url": "/collections/midland-gxt1050vp4-radio-accessories"
      },
      {
        "name": "Midland LXT600VP3 & LXT118 Radio",
        "url": "/collections/midland-lxt600vp3-lxt118-radio-accessories"
      },
      {
        "name": "Midland MB400 Two-Way Radio",
        "url": "/collections/midland-mb400-radio-accessories"
      },
      {
        "name": "Midland Two-Way Radio",
        "url": "/collections/midland-radios-accessories"
      },
      {
        "name": "Midland X-TALKER T10 Two-Way Radio",
        "url": "/collections/midland-x-talker-t10-radio-accessories"
      },
      {
        "name": "Midland X-TALKER T51VP3",
        "url": "/collections/midland-x-talker-t51vp3-radio-accessories"
      }
    ],
    "Motorola": [
      {
        "name": "Motorola Advisor TPG2200 Tetra Two-Way Pager Case & Holster",
        "url": "/collections/motorola-advisor-tpg2200-tetra-pager-accessories"
      },
      {
        "name": "Motorola APX 3000 Two-Way Radio",
        "url": "/collections/motorola-apx-3000-radio-accessories"
      },
      {
        "name": "Motorola APX 4000XH Case & Holster",
        "url": "/collections/motorola-apx-4000xh-case-holster"
      },
      {
        "name": "Motorola APX 6000XE Two-Way Radio",
        "url": "/collections/motorola-apx-6000xe-radio-accessories"
      },
      {
        "name": "Motorola APX 8000 Two-Way Radio",
        "url": "/collections/motorola-apx-8000-radio-accessories"
      },
      {
        "name": "Motorola APX 8000H Two-Way Radio",
        "url": "/collections/motorola-apx-8000h-radio-accessories"
      },
      {
        "name": "Motorola APX 8000XE Two-Way Radio",
        "url": "/collections/motorola-apx-8000xe-radio-accessories"
      },
      {
        "name": "Motorola APX 900 Two-Way Radio",
        "url": "/collections/motorola-apx-900-radio-accessories"
      },
      {
        "name": "Motorola APX N30 Two-Way Radio",
        "url": "/collections/motorola-apx-n30-radio-accessories"
      },
      {
        "name": "Motorola APX N50 Two-Way Radio",
        "url": "/collections/motorola-apx-n50-radio-accessories"
      },
      {
        "name": "Motorola APX Next Two-Way Radio",
        "url": "/collections/motorola-apx-next-radio-accessories"
      },
      {
        "name": "Motorola APX Next XE Two-Way Radio",
        "url": "/collections/motorola-apx-next-xe-radio-accessories"
      },
      {
        "name": "Motorola APX Next XN Two-Way Radio",
        "url": "/collections/motorola-apx-next-xn-radio-accessories"
      },
      {
        "name": "Motorola CLP1010e Two-Way Radio",
        "url": "/collections/motorola-clp1010e-radio-accessories"
      },
      {
        "name": "Motorola CP185 Two-Way Radio",
        "url": "/collections/motorola-cp185-radio-accessories"
      },
      {
        "name": "Motorola CP200d Two-Way Radio",
        "url": "/collections/motorola-cp200d-radio-accessories"
      },
      {
        "name": "Motorola Curve Two-Way Radio",
        "url": "/collections/motorola-curve-radio-accessories"
      },
      {
        "name": "Motorola DEP 450 Two-Way Radio",
        "url": "/collections/motorola-dep-450-radio-accessories"
      },
      {
        "name": "Motorola DTR620 Two-Way Radio",
        "url": "/collections/motorola-dtr620-radio-accessories"
      },
      {
        "name": "Motorola DTR720 Case & Holster",
        "url": "/collections/motorola-dtr720-radio-accessories"
      },
      {
        "name": "Motorola LEX L11 Handheld",
        "url": "/collections/motorola-lex-l11-radio-accessories"
      },
      {
        "name": "Motorola MOTOTRBO ION Two-Way Radio",
        "url": "/collections/motorola-mototrbo-ion-radio-accessories"
      },
      {
        "name": "Motorola Mototrbo R2 Two-Way Radio",
        "url": "/collections/motorola-mototrbo-r2-radio-accessories"
      },
      {
        "name": "Motorola Mototrbo R7 Two-Way Radio",
        "url": "/collections/motorola-mototrbo-r7-radio-accessories"
      },
      {
        "name": "Motorola MOTOTRBO SL300 Two-Way Radio",
        "url": "/collections/motorola-mototrbo-sl300-radio-accessories"
      },
      {
        "name": "Motorola MOTOTRBO SL4000e Two-Way Radio",
        "url": "/collections/motorola-mototrbo-sl4000e-radio-accessories"
      },
      {
        "name": "Motorola MOTOTRBO SL4010e Two-Way Radio",
        "url": "/collections/motorola-mototrbo-sl4010e-radio-accessories"
      },
      {
        "name": "Motorola MOTOTRBO SL7550/E Two-Way Radio",
        "url": "/collections/motorola-mototrbo-sl7550-e-radio-accessories"
      },
      {
        "name": "Motorola MOTOTRBO SL7580/E Two-Way Radio",
        "url": "/collections/motorola-mototrbo-sl7580-e-radio-accessories"
      },
      {
        "name": "Motorola MOTOTRBO SL7590/E Two-Way Radio",
        "url": "/collections/motorola-mototrbo-sl7590-e-radio-accessories"
      },
      {
        "name": "Motorola Nitro Evolve Two-Way Radio",
        "url": "/collections/motorola-nitro-evolve-radio-accessories"
      },
      {
        "name": "Motorola Nitro SLN 1000 Two-Way Radio",
        "url": "/collections/motorola-nitro-sln-1000-radio-accessories"
      },
      {
        "name": "Motorola RMM2050 Two-Way Radio",
        "url": "/collections/motorola-rmm2050-radio-accessories"
      },
      {
        "name": "Motorola RMU2040 Two-Way Radio",
        "url": "/collections/motorola-rmu2040-radio-accessories"
      },
      {
        "name": "Motorola RMU2080/D Case & Holster",
        "url": "/collections/motorola-rmu2080-d-radio-accessories"
      },
      {
        "name": "Motorola T107 Two-Way Radio",
        "url": "/collections/motorola-t107-radio-accessories"
      },
      {
        "name": "Motorola T200 Case & Holster",
        "url": "/collections/motorola-t200-radio-accessories"
      },
      {
        "name": "Motorola T200TP Case & Holster",
        "url": "/collections/motorola-t200tp-radio-accessories"
      },
      {
        "name": "Motorola T260TP Case & Holster",
        "url": "/collections/motorola-t260tp-radio-accessories"
      },
      {
        "name": "Motorola T270 Two-Way Radio",
        "url": "/collections/motorola-t270-radio-accessories"
      },
      {
        "name": "Motorola T402 Case & Holster",
        "url": "/collections/motorola-t402-radio-accessories"
      },
      {
        "name": "Motorola T460 Two-Way Radio",
        "url": "/collections/motorola-t460-radio-accessories"
      },
      {
        "name": "Motorola T465 Case & Holster",
        "url": "/collections/motorola-t465-radio-accessories"
      },
      {
        "name": "Motorola T600 Two-Way Radio",
        "url": "/collections/motorola-t600-radio-accessories"
      },
      {
        "name": "Motorola T605 Two-Way Radio",
        "url": "/collections/motorola-t605-radio-accessories"
      },
      {
        "name": "Motorola T800 Two-Way Radio",
        "url": "/collections/motorola-t800-radio-accessories"
      },
      {
        "name": "Motorola Talkabout T110 Two-Way Radio",
        "url": "/collections/motorola-talkabout-t110-radio-accessories"
      },
      {
        "name": "Motorola Talkabout T380 Two-Way Radio",
        "url": "/collections/motorola-talkabout-t380-radio-accessories"
      },
      {
        "name": "Motorola Talkabout T470 Two-Way Radio",
        "url": "/collections/motorola-talkabout-t470-radio-accessories"
      },
      {
        "name": "Motorola Talkabout T478 Two-Way Radio",
        "url": "/collections/motorola-talkabout-t478-radio-accessories"
      },
      {
        "name": "Motorola Talkabout Two-Way Radio",
        "url": "/collections/motorola-talkabout-t210-radio-accessories"
      },
      {
        "name": "Motorola Two-Way Radio",
        "url": "/collections/motorola-radios-accessories"
      },
      {
        "name": "Motorola VL50 Two-Way Radio",
        "url": "/collections/motorola-vl50-radio-accessories"
      },
      {
        "name": "Motorola XPR 3500e Radio",
        "url": "/collections/motorola-xpr-3500e-radio-accessories"
      },
      {
        "name": "Motorola XPR 7380e Two-Way Radio",
        "url": "/collections/motorola-xpr-7380e-radio-accessories"
      }
    ],
    "Retevis": [
      {
        "name": "Retevis H777 Two-Way Radio",
        "url": "/collections/retevis-h777-radio-accessories"
      },
      {
        "name": "Retevis RB19 Two-Way Radio",
        "url": "/collections/retevis-rb19-radio-accessories"
      },
      {
        "name": "Retevis RB27 GMRS Two-Way Radio",
        "url": "/collections/retevis-rb27-gmrs-radio-accessories"
      },
      {
        "name": "Retevis RB48 Two-Way Radio",
        "url": "/collections/retevis-rb48-radio-accessories"
      },
      {
        "name": "Retevis RT1 Two-Way Radio",
        "url": "/collections/retevis-rt1-radio-accessories"
      },
      {
        "name": "Retevis RT18 Two-Way Radio",
        "url": "/collections/retevis-rt18-radio-accessories"
      },
      {
        "name": "Retevis RT19 Two-Way Radio",
        "url": "/collections/retevis-rt19-radio-accessories"
      },
      {
        "name": "Retevis RT21 Two-Way Radio",
        "url": "/collections/retevis-rt21-radio-accessories"
      },
      {
        "name": "Retevis RT22/RT22S Two-Way Radio",
        "url": "/collections/retevis-rt22-rt22s-radio-accessories"
      },
      {
        "name": "Retevis RT27 Two-Way Radio",
        "url": "/collections/retevis-rt27-radio-accessories"
      },
      {
        "name": "Retevis RT29 Two-Way Radio",
        "url": "/collections/retevis-rt29-radio-accessories"
      },
      {
        "name": "Retevis RT68/RT668 Two-Way Radio",
        "url": "/collections/retevis-rt68-rt668-radio-accessories"
      },
      {
        "name": "Retevis Two-Way Radio",
        "url": "/collections/retevis-radios-accessories"
      }
    ],
    "Rocky Talkie": [
      {
        "name": "Rocky Talkie 5 Watt Radio Case & Holster",
        "url": "/collections/rocky-talkie-5-watt-radio-accessories"
      },
      {
        "name": "Rocky Talkie Mountain Radio Case & Holster",
        "url": "/collections/rocky-talkie-mountain-radio-accessories"
      },
      {
        "name": "Rocky Talkie Radio",
        "url": "/collections/rocky-talkie-radios-accessories"
      }
    ],
    "Siyata": [
      {
        "name": "Siyata Radio",
        "url": "/collections/siyata-radios-accessories"
      },
      {
        "name": "Siyata SD7 Case, Holster",
        "url": "/collections/siyata-sd7-radio-accessories"
      }
    ],
    "Tait": [
      {
        "name": "Tait Multiband Portables Radio",
        "url": "/collections/tait-radios-accessories"
      }
    ],
    "Unication": [
      {
        "name": "Unication G2 Voice Pager",
        "url": "/collections/unication-g2-pager-accessories"
      },
      {
        "name": "Unication G3 Voice Pager",
        "url": "/collections/unication-g3-pager-accessories"
      },
      {
        "name": "Unication G4 Voice Pager",
        "url": "/collections/unication-g4-pager-accessories"
      },
      {
        "name": "Unication G5 Voice Pager",
        "url": "/collections/unication-g5-pager-accessories"
      },
      {
        "name": "Unication Voice Pager",
        "url": "/collections/unication-pagers-accessories"
      }
    ],
    "Uniden": [
      {
        "name": "Uniden Atlantis 155 Two-Way Radio Case & Holster",
        "url": "/collections/uniden-atlantis-155-radio-accessories"
      },
      {
        "name": "Uniden Atlantis 275 Two-Way Radio Case & Holster",
        "url": "/collections/uniden-atlantis-275-radio-accessories"
      },
      {
        "name": "Uniden BC75XLT Radio",
        "url": "/collections/uniden-bc75xlt-radio-accessories"
      },
      {
        "name": "Uniden Bearcat SR30C Radio",
        "url": "/collections/uniden-bearcat-sr30c-radio-accessories"
      },
      {
        "name": "Uniden MHS75 Radio Scanner",
        "url": "/collections/uniden-mhs75-radio-accessories"
      },
      {
        "name": "Uniden Radio",
        "url": "/collections/uniden-radios-accessories"
      },
      {
        "name": "Uniden UR7 Case & Holster",
        "url": "/collections/uniden-ur7-radio-accessories"
      }
    ]
  },
  "medical": {
    "Clarius": [
      {
        "name": "Clarius C3 HD3 Handheld Ultrasound",
        "url": "/collections/clarius-c3-hd3-ultrasound-accessories"
      },
      {
        "name": "Clarius Ultrasound Scanner",
        "url": "/collections/clarius-ultrasound-accessories"
      }
    ],
    "Dexcom": [
      {
        "name": "Dexcom G6 Receiver Case, Holster",
        "url": "/collections/dexcom-g6-receiver-accessories"
      },
      {
        "name": "Dexcom G7 Receiver Case, Holster",
        "url": "/collections/dexcom-g7-receiver-accessories"
      },
      {
        "name": "Dexcom Receiver",
        "url": "/collections/dexcom-receiver-accessories"
      }
    ],
    "FreeStyle": [
      {
        "name": "Freestyle Libre 2 Case, Holster",
        "url": "/collections/freestyle-libre-2-cases-holsters"
      },
      {
        "name": "Freestyle Libre 3 Case, Holster",
        "url": "/collections/freestyle-libre-3-cases-holsters"
      },
      {
        "name": "Freestyle Libre/2",
        "url": "/collections/freestyle-libre-2-chargers-cables"
      },
      {
        "name": "FreeStyle Reader",
        "url": "/collections/freestyle-reader-accessories"
      }
    ],
    "Minimed": [
      {
        "name": "Minimed 770G",
        "url": "/collections/minimed-770g-cases-holsters"
      },
      {
        "name": "Minimed 780G",
        "url": "/collections/minimed-780g-cases-holsters"
      },
      {
        "name": "Minimed Medtronic MiniMed Insulin Pump",
        "url": "/collections/medtronic-minimed-insulin-pump-accessories-for-healthcare-enterprise-deployment"
      }
    ],
    "Omnipod": [
      {
        "name": "Omnipod 5 Controller",
        "url": "/collections/omnipod-5-controller-cases-chargers-accessories"
      }
    ],
    "SonoQue": [
      {
        "name": "SonoQue C3 Holster & Case",
        "url": "/collections/sonoque-c3-holster-case"
      },
      {
        "name": "SonoQue C4PL Holster & Case",
        "url": "/collections/sonoque-c4pl-holster-case"
      },
      {
        "name": "SonoQue C5 Holster & Case",
        "url": "/collections/sonoque-c5-holster-case"
      },
      {
        "name": "SonoQue C5PL Holster & Case",
        "url": "/collections/sonoque-c5pl-holster-case"
      },
      {
        "name": "SonoQue L3 Holster & Case",
        "url": "/collections/sonoque-l3-holster-case"
      },
      {
        "name": "SonoQue L5 Holster & Case",
        "url": "/collections/sonoque-l5-holster-case"
      },
      {
        "name": "SonoQue Wireless Ultrasound",
        "url": "/collections/sonoque-wireless-ultrasound-accessories"
      }
    ],
    "Tandem": [
      {
        "name": "Tandem Insulin Pump",
        "url": "/collections/tandem-pump-cases-holders"
      },
      {
        "name": "Tandem T:slim x2 Case, Holster",
        "url": "/collections/tandem-t-slim-x2-cases-holsters"
      }
    ]
  },
  "tools": {
    "Klein Tools": [
      {
        "name": "Klein Tools MM440 Case & Holster",
        "url": "/collections/klein-tools-mm440-portable-handheld-tool-accessories"
      },
      {
        "name": "Klein Tools MM600 Case & Holster",
        "url": "/collections/klein-tools-mm600-portable-handheld-tool-accessories"
      },
      {
        "name": "Klein Tools MM700 Case & Holster",
        "url": "/collections/klein-tools-mm700-portable-handheld-tool-accessories"
      },
      {
        "name": "Klein Tools RT250 GFCI Receptacle Tester Case & Holster",
        "url": "/collections/klein-tools-rt250-gfci-portable-handheld-tool-accessories"
      }
    ],
    "Leica": [
      {
        "name": "Leica BLK3D Holster & Case",
        "url": "/collections/leica-blk3d-portable-handheld-tool-accessories"
      },
      {
        "name": "Leica DISTO D1 Holster & Case",
        "url": "/collections/leica-disto-d1-portable-handheld-tool-accessories"
      },
      {
        "name": "Leica DISTO D2 Holster & Case",
        "url": "/collections/leica-disto-d2-portable-handheld-tool-accessories"
      },
      {
        "name": "Leica DISTO D810 Holster & Case",
        "url": "/collections/leica-disto-d810-portable-handheld-tool-accessories"
      },
      {
        "name": "Leica DISTO E7500i Case & Holster",
        "url": "/collections/leica-disto-e7500i-portable-handheld-tool-accessories"
      },
      {
        "name": "Leica DISTO X3 Holster & Case",
        "url": "/collections/leica-disto-x3-portable-handheld-tool-accessories"
      },
      {
        "name": "Leica DISTO X4 Holster & Case",
        "url": "/collections/leica-disto-x4-portable-handheld-tool-accessories"
      }
    ],
    "Makita": [
      {
        "name": "Makita LD0 Laser Measure",
        "url": "/collections/makita-ld0-portable-handheld-tool-accessories"
      }
    ],
    "Milwaukee": [
      {
        "name": "Milwaukee Laser Distance",
        "url": "/collections/milwaukee-portable-handheld-tools-accessories"
      }
    ]
  }
};
